(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6064,3264],{

/***/ 36981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Button = function Button(_ref) {
  var icondown = _ref.icondown,
      onSubmit = _ref.onSubmit,
      text = _ref.text,
      src = _ref.src,
      img = _ref.img,
      hoverImg = _ref.hoverImg,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      margin = _ref.margin,
      background = _ref.background,
      borderRadius = _ref.borderRadius,
      border = _ref.border,
      width = _ref.width,
      height = _ref.height,
      hoverBackground = _ref.hoverBackground,
      target = _ref.target,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      icon = _ref.icon,
      padding = _ref.padding,
      newtablink = _ref.newtablink,
      iconvideo = _ref.iconvideo;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBtn, {
    className: "dc-btn fade-up",
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    background: background,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    margin: margin,
    border: border,
    img: img,
    borderRadius: borderRadius,
    width: width,
    hoverImg: hoverImg,
    hoverBackground: hoverBackground,
    height: height,
    borderColor: borderColor,
    target: target,
    hoverColor: hoverColor,
    onSubmit: onSubmit,
    padding: padding,
    children: // ok
    src ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: src || '/',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
          children: text
        })
      })
    }) : newtablink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: newtablink || '/',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
          children: ["  ", icon ? icondown ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "19",
            height: "20",
            viewBox: "0 0 19 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "download",
              transform: "translate(-3.637 -3)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8769",
                "data-name": "Path 8769",
                d: "M4.692,16a1.054,1.054,0,0,1,1.056,1.053v2.105a1.051,1.051,0,0,0,.309.744h0a1.057,1.057,0,0,0,.746.308H19.47a1.054,1.054,0,0,0,1.056-1.053V17.053a1.056,1.056,0,0,1,2.111,0v2.105a3.162,3.162,0,0,1-3.167,3.158H6.8a3.162,3.162,0,0,1-3.167-3.158V17.053A1.054,1.054,0,0,1,4.692,16Z",
                transform: "translate(0 0.684)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8770",
                "data-name": "Path 8770",
                d: "M6.946,10.308a1.058,1.058,0,0,1,1.493,0l4.531,4.519L17.5,10.308A1.054,1.054,0,0,1,18.994,11.8L13.716,17.06a1.058,1.058,0,0,1-1.493,0L6.946,11.8A1.051,1.051,0,0,1,6.946,10.308Z",
                transform: "translate(0.167 0.368)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8771",
                "data-name": "Path 8771",
                d: "M12.692,3a1.054,1.054,0,0,1,1.056,1.053V16.684a1.056,1.056,0,0,1-2.111,0V4.053A1.054,1.054,0,0,1,12.692,3Z",
                transform: "translate(0.444)",
                fill: "#fff",
                fillRule: "evenodd"
              })]
            })
          }) : iconvideo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20.003",
            height: "20",
            viewBox: "0 0 20.003 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_19478",
              "data-name": "Group 19478",
              transform: "translate(-158 -480)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8772",
                "data-name": "Path 8772",
                d: "M19.558,25.667H17a2.318,2.318,0,0,0-4.449,0H1.667a.667.667,0,0,0,0,1.334H12.555A2.318,2.318,0,0,0,17,27h2.554a.667.667,0,0,0,0-1.334ZM14.78,27.333a1,1,0,1,1,1-1A1,1,0,0,1,14.78,27.333Z",
                transform: "translate(157 471.336)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8773",
                "data-name": "Path 8773",
                d: "M18.909,1H3.094A2.1,2.1,0,0,0,1,3.094V13.575a2.1,2.1,0,0,0,2.094,2.094H18.909A2.1,2.1,0,0,0,21,13.575V3.094A2.1,2.1,0,0,0,18.909,1Zm.76,12.575a.761.761,0,0,1-.76.76H3.094a.761.761,0,0,1-.76-.76V3.094a.761.761,0,0,1,.76-.76H18.909a.761.761,0,0,1,.76.76Z",
                transform: "translate(157 479)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8774",
                "data-name": "Path 8774",
                d: "M18.354,9.435,13.02,6.1A.667.667,0,0,0,12,6.667v6.668a.667.667,0,0,0,1.02.565l5.334-3.334a.667.667,0,0,0,0-1.133Zm-5.021,2.7V7.867L16.743,10Z",
                transform: "translate(153.334 477.334)"
              })]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "login_2",
              "data-name": "login 2",
              transform: "translate(-3.25)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8718",
                "data-name": "Path 8718",
                d: "M12.107,3.25a.857.857,0,1,0,0,1.714,8.286,8.286,0,0,1,0,16.571.857.857,0,1,0,0,1.714,10,10,0,0,0,0-20Z",
                transform: "translate(1.143 -3.25)",
                fill: "#fff"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8719",
                "data-name": "Path 8719",
                d: "M11.5,9.713A.857.857,0,1,1,12.713,8.5l3.429,3.429a.857.857,0,0,1,0,1.212L12.713,16.57A.857.857,0,1,1,11.5,15.358l1.965-1.965H4.107a.857.857,0,0,1,0-1.714h9.359Z",
                transform: "translate(0 -2.536)",
                fill: "#fff"
              })]
            })
          }) : '', text]
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: 'javascript:void(0)',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
          children: ["  ", icon ? icondown ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "19",
            height: "20",
            viewBox: "0 0 19 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "download",
              transform: "translate(-3.637 -3)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8769",
                "data-name": "Path 8769",
                d: "M4.692,16a1.054,1.054,0,0,1,1.056,1.053v2.105a1.051,1.051,0,0,0,.309.744h0a1.057,1.057,0,0,0,.746.308H19.47a1.054,1.054,0,0,0,1.056-1.053V17.053a1.056,1.056,0,0,1,2.111,0v2.105a3.162,3.162,0,0,1-3.167,3.158H6.8a3.162,3.162,0,0,1-3.167-3.158V17.053A1.054,1.054,0,0,1,4.692,16Z",
                transform: "translate(0 0.684)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8770",
                "data-name": "Path 8770",
                d: "M6.946,10.308a1.058,1.058,0,0,1,1.493,0l4.531,4.519L17.5,10.308A1.054,1.054,0,0,1,18.994,11.8L13.716,17.06a1.058,1.058,0,0,1-1.493,0L6.946,11.8A1.051,1.051,0,0,1,6.946,10.308Z",
                transform: "translate(0.167 0.368)",
                fill: "#fff",
                fillRule: "evenodd"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8771",
                "data-name": "Path 8771",
                d: "M12.692,3a1.054,1.054,0,0,1,1.056,1.053V16.684a1.056,1.056,0,0,1-2.111,0V4.053A1.054,1.054,0,0,1,12.692,3Z",
                transform: "translate(0.444)",
                fill: "#fff",
                fillRule: "evenodd"
              })]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "login_2",
              "data-name": "login 2",
              transform: "translate(-3.25)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8718",
                "data-name": "Path 8718",
                d: "M12.107,3.25a.857.857,0,1,0,0,1.714,8.286,8.286,0,0,1,0,16.571.857.857,0,1,0,0,1.714,10,10,0,0,0,0-20Z",
                transform: "translate(1.143 -3.25)",
                fill: "#fff"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
                id: "Path_8719",
                "data-name": "Path 8719",
                d: "M11.5,9.713A.857.857,0,1,1,12.713,8.5l3.429,3.429a.857.857,0,0,1,0,1.212L12.713,16.57A.857.857,0,1,1,11.5,15.358l1.965-1.965H4.107a.857.857,0,0,1,0-1.714h9.359Z",
                transform: "translate(0 -2.536)",
                fill: "#fff"
              })]
            })
          }) : '', text]
        })
      })
    })
  });
};

var StyledBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Button__StyledBtn",
  componentId: "sc-1qz5gh2-0"
})(["&.dc-btn{margin:", ";width:", ";height:", "px;cursor:pointer;a{display:flex;width:", ";height:100%;align-items:center;justify-content:center;font-size:", "px;font-weight:", ";margin:0;line-height:", "px;background-color:", ";position:relative;border-radius:", "px;overflow:hidden;z-index:0;transition:border 1s cubic-bezier(.25,.74,.22,.99);padding:", ";box-sizing:border-box;border:", ";border-color:", ";border-style:", ";span{transition:all 1s cubic-bezier(.25,.74,.22,.99);color:", ";position:relative;z-index:2;top:2px;line-height:45px;svg{margin-right:8px;line{transition:all 1s cubic-bezier(.25,.74,.22,.99);}path{transition:all 1s cubic-bezier(.25,.74,.22,.99);}}}&:before{bottom:0;content:\"\";display:block;position:absolute;right:0;top:0;left:0;background-color:", ";height:100%;width:100%;margin:auto;transition:all 1s cubic-bezier(.25,.74,.22,.99);border-radius:22px;transform:translateY(100px);}&:hover{span{color:", ";}svg{line{stroke:", ";}path{fill:", ";}}&:before{transform:translate(0);}}&:focus{color:#222222;}}}"], function (props) {
  return props.margin || '0';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '44';
}, function (props) {
  return props.width || 'fit-content';
}, function (props) {
  return props.fontSize || '16';
}, function (props) {
  return props.fontWeight || 500;
}, function (props) {
  return props.lineHeight || '24';
}, function (props) {
  return props.background || "#978C21";
}, function (props) {
  return props.borderRadius || '22';
}, function (props) {
  return props.padding || "0px 36px";
}, function (props) {
  return props.border || "none";
}, function (props) {
  return props.borderColor || "transparent";
}, function (props) {
  return props.border ? 'solid' : "transparent";
}, function (props) {
  return props.color || "#FFFFFF";
}, function (p) {
  return p.hoverBackground || '#3C3C3B';
}, function (props) {
  return props.hoverColor || "#FFF";
}, function (props) {
  return props.hoverColor || '#FFF';
}, function (props) {
  return props.hoverColor || '#FFF';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Button));

/***/ }),

/***/ 18990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var C_DC_shanta_next_page_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97346);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25317);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(62642);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(63750);
/* harmony import */ var react_outside_click_handler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39834);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(68312);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36981);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93264);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22920);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87536);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92495);
/* harmony import */ var _pages_api_redux_home__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,C_DC_shanta_next_page_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var MainMenu = function MainMenu(_ref) {
  var _formState$errors, _formState$errors$ema;

  var offset = _ref.offset,
      hovered = _ref.hovered,
      MenuOpen = _ref.MenuOpen,
      ClickShanta = _ref.ClickShanta;
  // variable
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var pathname = location.pathname;
  var tl = new gsap__WEBPACK_IMPORTED_MODULE_12__/* .TimelineLite */ .Vq();
  var mobileMenuRaf = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var menuRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(); // const hamburgerRef = useRef();

  var hamburgerDesktopRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var hamburgerCloseRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var searchClickRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var searchItemRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      activehanta = _useState[0],
      setActivehanta = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      showSubmenu = _useState2[0],
      setShowSubmenu = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(MenuOpen ? MenuOpen : false),
      isMenuOpen = _useState3[0],
      setIsMenuOpen = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(ClickShanta ? ClickShanta : false),
      isHandleClickShanta = _useState4[0],
      setIsHandleClickShanta = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(hovered ? hovered : 'all'),
      hoveredAttr = _useState5[0],
      setHoveredAttr = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      searchInput = _useState6[0],
      setSearchInput = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      windowWidth = _useState7[0],
      setWindowWidth = _useState7[1]; // get offset for container


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    // Function to handle window resize
    var handleResize = function handleResize() {
      setWindowWidth(windowWidth);
    }; // Initial window width


    setWindowWidth(windowWidth); // Add event listener for window resize

    window.addEventListener('resize', handleResize); // Cleanup the event listener on component unmount

    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // search handle

  var handleInput = function handleInput(e) {
    setSearchInput(e.target.value);
  };

  var searchSubmit = function searchSubmit(e) {
    e.preventDefault();

    if (searchInput === '') {
      return;
    } else {
      window.location.href = "/search?keyword=".concat(searchInput);
      document.querySelector('.search-desktop').classList.remove('search-open');
      gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
        duration: .4,
        height: 0,
        opacity: 0,
        overflow: 'hidden'
      });
      gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current.querySelector('.container'), {
        opacity: 0
      }, '-=.4');
      gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
        display: 'none'
      });
    } // setSearchInput('')

  }; // remov all menu and search function menu


  var remove_all = function remove_all(e) {
    var search = document.querySelectorAll(".search-desktop");
    search.forEach(function (i) {
      i.classList.remove("search-open");
    }); // disableBodyScroll(e);
    // clearAllBodyScrollLocks(e)
  };

  var remove_search = function remove_search(e) {
    setSearchInput('');
    document.querySelector('.search-desktop').classList.remove('search-open');
    gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
      duration: .4,
      height: 0,
      opacity: 0,
      overflow: 'hidden'
    });
    gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current.querySelector('.container'), {
      opacity: 0
    }, '-=.4');
    gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
      display: 'none'
    });
    document.querySelector('body').classList.remove('open_menu'); // disableBodyScroll(e);
    // clearAllBodyScrollLocks(e)
    // remove_all();
  };

  var remove_all_mobile = function remove_all_mobile(e) {// var menuOpen = document.querySelectorAll(".Mobile-menu-wrap");
    // var hamburger = document.querySelectorAll(".hamburger");
    // var menu = document.querySelectorAll(".main_child");
    // var menuSub = document.querySelectorAll(".main-child-sub ")
    // var menuSubSub = document.querySelectorAll(".main-child-sub-sub");
    // hamburger.forEach((i) => {
    //     i.classList.remove("menu-open");
    //     gsap.to(menuRef.current, {
    //         opacity: 0, duration: ".2",
    //     });
    //     gsap.to(menuRef.current, {
    //         display: "none",
    //     });
    // });
    // menuOpen.forEach((i) => {
    //     i.classList.remove("menu-open");
    //
    // });
    //
    // menu.forEach((i) => {
    //     i.classList.remove("submenu-open-mb");
    //
    // });
    // menuSub.forEach((i) => {
    //     i.classList.remove("submenu-open-next");
    //
    // });
    // menuSubSub.forEach((i) => {
    //     i.classList.remove("submenu-open-next-next");
    //     i.classList.remove("submenu-open-next");
    //     i.classList.remove("submenu-open-mb");
    //
    // });
    // setHoveredAttr('all');
    //
    // const mobile = document.querySelector("#mobile-subscribe");
    // mobile.classList.remove('visible')
    // disableBodyScroll(e);
    // clearAllBodyScrollLocks(e)
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var body = document.body;
    var scrollUp = "scroll-up";
    var scrollDown = "scroll-down"; // Mobile menu start
    // for mobile submenu

    var getDropdownChildMobile = document.querySelectorAll(".main_child");
    getDropdownChildMobile.forEach(function (i) {
      i.addEventListener("click", function (r) {
        if (r.target.parentElement.classList.contains('submenu-open-mb')) {
          r.target.parentElement.classList.remove("submenu-open-mb");
        } else {
          r.target.parentElement.classList.toggle("submenu-open-mb");
          document.querySelector('.submenu-open-mb').addEventListener('click', function (ne) {
            var parent = ne.target.parentElement;
            parent.parentElement.classList.remove("submenu-open-mb");
          });
        }
      });
    });
    var nextStepChild = document.querySelectorAll(".main-child-sub");
    nextStepChild.forEach(function (i) {
      i.addEventListener("click", function (r) {
        if (r.target.parentElement.classList.contains('submenu-open-next')) {
          r.target.parentElement.classList.remove("submenu-open-next");
        } else {
          r.target.parentElement.classList.toggle("submenu-open-next");
          document.querySelector('.submenu-open-next').addEventListener('click', function (ne) {
            var parent = ne.target.parentElement;
            parent.parentElement.classList.remove("submenu-open-next");
          });
        }
      });
    });
    var nextStepChildChild = document.querySelectorAll(".main-child-sub-sub");
    nextStepChildChild.forEach(function (i) {
      i.addEventListener("click", function (r) {
        if (r.target.parentElement.classList.contains('submenu-open-next-next')) {
          r.target.parentElement.classList.remove("submenu-open-next-next");
        } else {
          r.target.parentElement.classList.toggle("submenu-open-next-next");
          document.querySelector('.submenu-open-next-next').addEventListener('click', function (ne) {
            var parent = ne.target.parentElement;
            parent.parentElement.classList.remove("submenu-open-next-next");
          });
        }
      });
    }); // menu click on mobile
    // hamburgerRef.current.addEventListener("click", (e) => {
    //     document.querySelector(".hamburger").classList.add("menu-open");
    //     document.querySelector(".Mobile-menu-wrap").classList.add("menu-open");
    //     gsap.to(menuRef.current, {
    //         display: "block",
    //     });
    //     gsap.to(menuRef.current, {
    //         opacity: 1, duration: ".3",
    //     });
    //     // disableBodyScroll(e);
    //     // clearAllBodyScrollLocks(e)
    // });
    // hamburgerCloseRef.current.addEventListener("click", (e) => {
    //     document.querySelector(".hamburger").classList.remove("menu-open");
    //     document.querySelector(".Mobile-menu-wrap").classList.remove("menu-open");
    //     gsap.to(menuRef.current, {
    //         opacity: 0, duration: ".2",
    //     });
    //     gsap.to(menuRef.current, {
    //         display: "none",
    //     });
    //     // enableBodyScroll(e);
    //     // clearAllBodyScrollLocks(e);
    //     remove_all_mobile(e);
    //
    // });
    // Mobile menu end
    // search desktop

    searchClickRef.current.addEventListener("click", function () {
      if (!searchItemRef.current.classList.contains("search-open")) {
        searchItemRef.current.classList.add("search-open");
        gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
          display: "flex"
        });
        gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
          duration: 0.5,
          height: 195,
          opacity: 1,
          overflow: "visible"
        });
        gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current.querySelector(".container"), {
          opacity: 1,
          delay: 0.2
        });
        document.querySelector('body').classList.add('open_menu');
      } else {
        document.querySelector('body').classList.remove('open_menu');
        document.body.classList.remove('menu-open');
        searchItemRef.current.classList.remove("search-open");
        gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
          duration: 0.4,
          height: 0,
          opacity: 0,
          overflow: "hidden"
        });
        gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current.querySelector(".container"), {
          opacity: 0
        }, "-=.4");
        gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
          display: "none"
        });
      }

      setIsMenuOpen(false);
      var height = "0";
      var opacity = "0";
      setIsHandleClickShanta(false);
      tl.to(".desktop-menu__bottom .mega_menu .fixed_menu .content", {
        duration: 0.5,
        opacity: opacity,
        ease: "power2.out"
      }).to(".desktop-menu__bottom .mega_menu .fixed_menu  .social li", {
        duration: 0.3,
        opacity: opacity,
        ease: "power2.out"
      }, "-=0.2").to(".desktop-menu__bottom .mega_menu .content_wrap .dc-btn", {
        duration: 0.2,
        opacity: opacity,
        stagger: 0.09,
        ease: "power2.out"
      }, "-=0.1").to(".desktop-menu__bottom .mega_menu .content_wrap li", {
        duration: 0.3,
        opacity: opacity,
        stagger: 0.01,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".mega_menu"), {
        height: height,
        duration: 0.3,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".desktop-menu__bottom"), {
        height: height,
        duration: 0.3,
        ease: "power2.out"
      }, "-=0.3");
      tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
        width: '0',
        paddingLeft: '0',
        paddingRight: '0',
        opacity: '1',
        duration: 0.3,
        ease: 'power2.out',
        xPercent: '0'
      }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
        duration: 0.2,
        opacity: '0',
        x: 0,
        stagger: 0.1,
        ease: 'power2.out'
      }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
        width: '65.5%',
        duration: 0.5,
        ease: 'power2.out'
      }, "-=0.3");
    });
    var searchLine = document.querySelector('svg  #Ellipse_19');
    searchClickRef.current.addEventListener("mouseover", function () {
      searchLine.style.strokeDasharray = '142px';
      searchLine.style.opacity = '1';
      searchLine.style.transition = 'all 0.8s ease 0s';
      searchLine.setAttribute('stroke-dasharray', '142 142');
    });
    searchClickRef.current.addEventListener("mouseout", function () {
      searchLine.style.strokeDasharray = '0 142';
      searchLine.style.opacity = '0';
      searchLine.setAttribute('stroke-dasharray', '0');
    }); // on click hide search . should be reduce code later

    document.querySelector('.search-desktop svg').addEventListener('click', function () {
      searchItemRef.current.classList.remove('search-open');
      gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
        duration: .4,
        height: 0,
        opacity: 0,
        overflow: 'hidden'
      });
      gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current.querySelector('.container'), {
        opacity: 0
      }, '-=.4');
      gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(searchItemRef.current, {
        display: 'none'
      });
      setSearchInput('');
      document.querySelector('body').classList.remove('open_menu');
    }); //---- on scroll menu fixed action

    if (document.body.classList.contains("scroll-up")) {
      document.body.classList.remove("scroll-up");
    } // Clear any active scroll locks

  }, []); // in home page menu & logo click off

  var handleHamburgerClick = function handleHamburgerClick(e) {
    // Add or remove class from the body element
    setIsMenuOpen(function (prevActiveham) {
      return !prevActiveham;
    });
    setIsHandleClickShanta(true); // Set flag to true

    var height = isMenuOpen ? "0" : "auto";
    var opacity = isMenuOpen ? "0" : "1";
    var hidden = isMenuOpen ? "" : "menu-open";
    tl.to(document.querySelector(".desktop-menu__bottom"), {
      height: height,
      duration: 0.6,
      ease: 'Power1.easeOut'
    }, "-=0.3").to(document.querySelector(".mega_menu"), {
      height: height,
      duration: 0.3,
      ease: 'Power1.easeOut'
    }).to('.desktop-menu__bottom .mega_menu .content_wrap li', {
      duration: .5,
      opacity: opacity,
      delay: 0.3,
      stagger: 0.1,
      ease: 'Power1.easeOut'
    }, "0").to('.desktop-menu__bottom .mega_menu .content_wrap .dc-btn', {
      duration: .5,
      opacity: opacity,
      stagger: 0.1,
      ease: 'Power1.easeOut'
    }, "0").to('.desktop-menu__bottom .mega_menu .fixed_menu .content', {
      duration: .5,
      opacity: opacity,
      ease: 'Power1.easeOut'
    }, '-=0.5').to('.desktop-menu__bottom .mega_menu .fixed_menu  .social li', {
      duration: .5,
      opacity: opacity,
      ease: 'Power1.easeOut'
    }).to(document.querySelector('body'), {
      overflow: hidden,
      duration: 0.6,
      ease: 'Power1.easeOut'
    }, '-=0.3');

    if (activehanta) {
      handleclickshanta();
    }

    if (isMenuOpen) {
      setTimeout(function () {
        document.querySelector('body').classList.remove('open_menu'); // enableBodyScroll(e)
      }, 500);
    } else {
      setTimeout(function () {
        document.querySelector('body').classList.add('open_menu'); // disableBodyScroll(e)
        // clearAllBodyScrollLocks(e);
      }, 300);
    }
  };

  var handleclickshanta = function handleclickshanta(e) {
    setActivehanta(function (prevActivehanta) {
      return !prevActivehanta;
    });
    setIsHandleClickShanta(true); // Set flag to true

    var height = activehanta ? "0" : "100%";
    var opacity = activehanta ? "0" : "1";
    var width = activehanta ? "65.5%" : "34.5%";
    var widthm = activehanta ? "0" : "34.5%";
    var padding = activehanta ? "0" : "70px";
    var widthlink = activehanta ? "0" : "100%";
    var transform = activehanta ? "-100%" : "0";
    tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
      width: widthm,
      paddingLeft: padding,
      paddingRight: padding,
      opacity: '1',
      duration: 0.3,
      ease: 'power2.out',
      xPercent: transform
    }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
      duration: 0.2,
      opacity: opacity,
      x: 0,
      stagger: 0.1,
      ease: 'power2.out'
    }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
      width: width,
      duration: 0.5,
      ease: 'power2.out'
    }, "-=0.3");
    document.querySelector('body').classList.add('open_menu');
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {};

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  var removehidden = function removehidden(e) {
    setHoveredAttr('all'); // const mobile = document.querySelector("#mobile-subscribe");
    // mobile.classList.remove('visible')

    e.preventDefault();
  };

  var handleMouseEnter = function handleMouseEnter(attr) {
    setHoveredAttr(attr);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setHoveredAttr('all');
  };

  var headerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var headerRefMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var body = document.body;
    var scrollUp = "scroll-up";
    var scrollDown = "scroll-down";
    var lastScroll = 0;
    var howMuchScroll = 50;
    var windowWidth;

    var handleScroll = function handleScroll() {
      var currentScroll = window.pageYOffset;

      if (currentScroll <= howMuchScroll) {
        body.classList.remove(scrollUp);
        return;
      }

      if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
      } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
      }

      lastScroll = currentScroll;
    }; // Initial call


    handleScroll(); // Event listener

    window.addEventListener("scroll", handleScroll);
    return function () {
      // Clean up
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // news lett

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
  var responseData = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function (state) {
    return state.home;
  });

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useForm */ .cI)({
    mode: 'all'
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      reset = _useForm.reset; //--- form submit


  var success = function success(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.success */ .Am.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var error = function error(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var onSubmit = function onSubmit(e) {
    var api_services = _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_9__/* .ApiServices.ADDSUBSCRIP */ .u.ADDSUBSCRIP;
    var formData = new FormData();
    formData.append('email', e === null || e === void 0 ? void 0 : e.email);

    if (e.email !== '') {
      dispatch((0,_pages_api_redux_home__WEBPACK_IMPORTED_MODULE_10__/* .postForm */ .Md)([api_services, formData]));
      success('Successfully Submitted');
      reset();
    }
  };

  var count = 0;

  var onError = function onError(errors) {
    Object.values(errors).forEach(function (error) {
      count++;
    });

    if (count > 0) {
      react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error('please fill with  correct inputs');
    }

    count = 0;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.error) !== '') {
      error(responseData === null || responseData === void 0 ? void 0 : responseData.error);
    }

    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.success) !== '') {// success(responseData?.success)
    }
  }, [responseData]); //
  // const history = useHistory();
  //

  var handleClick = function handleClick() {
    router.push('/'); // Navigate to the root route ('/')
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (pathname == '/') {
      var _document$querySelect;

      document.body.classList.remove('sticky');
      document.body.classList.add('on-home');
      document.querySelector('.desktop-menu__top__logo a').addEventListener('click', function (e) {
        if (document.body.classList.contains('on-home')) {
          e.preventDefault();
        }
      });
      (_document$querySelect = document.querySelectorAll('.desktop-menu__bottom ul li a')[0]) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.addEventListener('click', function (e) {
        if (document.body.classList.contains('on-home')) {
          e.preventDefault();
        }
      });
      remove_all();
      remove_all_mobile();
      setIsMenuOpen(false);
      var height = "0";
      var opacity = "0";
      setIsHandleClickShanta(false);
      tl.to(".desktop-menu__bottom .mega_menu .fixed_menu .content", {
        duration: 0.5,
        opacity: opacity,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .fixed_menu  .social li", {
        duration: 0.5,
        opacity: opacity,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .content_wrap .dc-btn", {
        duration: 0.2,
        opacity: opacity,
        stagger: 0.09,
        ease: "power2.out"
      }, "-=0.3").to(".desktop-menu__bottom .mega_menu .content_wrap li", {
        duration: 0.3,
        opacity: opacity,
        stagger: 0.01,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".mega_menu"), {
        height: height,
        duration: 0.6,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".desktop-menu__bottom"), {
        height: height,
        duration: 0.3,
        ease: "power2.out"
      }, "-=0.3");
      tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
        width: '0',
        paddingLeft: '0',
        paddingRight: '0',
        opacity: '1',
        duration: 0.3,
        ease: 'power2.out',
        xPercent: '0'
      }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
        duration: 0.2,
        opacity: '0',
        x: 0,
        stagger: 0.1,
        ease: 'power2.out'
      }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
        width: '65.5%',
        duration: 0.5,
        ease: 'power2.out'
      }, "-=0.3"); //
      // disableBodyScroll();
      // clearAllBodyScrollLocks()

      document.querySelector('body').classList.remove('open_menu');
      document.querySelector('body').classList.remove('scroll-down'); // Revert body overflow to its original value on blur

      document.body.style.overflow = 'auto';
      var html = document.querySelector('html');
      html.style.overflow = 'auto';
    } else if (pathname == '/shanta-financial-literacy-program') {
      document.body.classList.add('sticky');
      document.querySelector('body').classList.remove('open_menu');
      document.querySelector('body').classList.remove('scroll-down');
      remove_all();
      remove_all_mobile();
      setIsMenuOpen(false);
      var _height = "0";
      var _opacity = "0";
      setIsHandleClickShanta(false);
      document.querySelector('body').classList.remove('open_menu');
      tl.to(".desktop-menu__bottom .mega_menu .fixed_menu .content", {
        duration: 0.5,
        opacity: _opacity,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .fixed_menu  .social li", {
        duration: 0.5,
        opacity: _opacity,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .content_wrap .dc-btn", {
        duration: 0.2,
        opacity: _opacity,
        stagger: 0.09,
        ease: "power2.out"
      }, "-=0.3").to(".desktop-menu__bottom .mega_menu .content_wrap li", {
        duration: 0.3,
        opacity: _opacity,
        stagger: 0.01,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".mega_menu"), {
        height: _height,
        duration: 0.6,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".desktop-menu__bottom"), {
        height: _height,
        duration: 0.3,
        ease: "power2.out"
      }, "-=0.3");
      tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
        width: '0',
        paddingLeft: '0',
        paddingRight: '0',
        opacity: '1',
        duration: 0.3,
        ease: 'power2.out',
        xPercent: '0'
      }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
        duration: 0.2,
        opacity: '0',
        x: 0,
        stagger: 0.1,
        ease: 'power2.out'
      }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
        width: '65.5%',
        duration: 0.5,
        ease: 'power2.out'
      }, "-=0.3"); // disableBodyScroll();
      // clearAllBodyScrollLocks()
      // Revert body overflow to its original value on blur

      document.body.style.overflow = 'auto';

      var _html = document.querySelector('html');

      _html.style.overflow = 'auto';
    } else if (pathname == '/easytrade') {
      document.body.classList.add('sticky');
      remove_all();
      remove_all_mobile();
      document.body.classList.remove('sticky');
      document.querySelector('body').classList.remove('open_menu');
      document.querySelector('body').classList.remove('scroll-down');
      setIsMenuOpen(false);
      var _height2 = "0";
      var _opacity2 = "0";
      setIsHandleClickShanta(false);
      tl.to(".desktop-menu__bottom .mega_menu .fixed_menu .content", {
        duration: 0.5,
        opacity: _opacity2,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .fixed_menu  .social li", {
        duration: 0.5,
        opacity: _opacity2,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .content_wrap .dc-btn", {
        duration: 0.2,
        opacity: _opacity2,
        stagger: 0.09,
        ease: "power2.out"
      }, "-=0.3").to(".desktop-menu__bottom .mega_menu .content_wrap li", {
        duration: 0.3,
        opacity: _opacity2,
        stagger: 0.01,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".mega_menu"), {
        height: _height2,
        duration: 0.6,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".desktop-menu__bottom"), {
        height: _height2,
        duration: 0.3,
        ease: "power2.out"
      }, "-=0.3");
      tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
        width: '0',
        paddingLeft: '0',
        paddingRight: '0',
        opacity: '1',
        duration: 0.3,
        ease: 'power2.out',
        xPercent: '0'
      }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
        duration: 0.2,
        opacity: '0',
        x: 0,
        stagger: 0.1,
        ease: 'power2.out'
      }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
        width: '65.5%',
        duration: 0.5,
        ease: 'power2.out'
      }, "-=0.3"); // disableBodyScroll();
      // clearAllBodyScrollLocks()
      // Revert body overflow to its original value on blur

      document.body.style.overflow = 'auto';

      var _html2 = document.querySelector('html');

      _html2.style.overflow = 'auto';
    } else if (pathname === '/our-services') {
      document.body.classList.add('services');
      document.body.classList.remove('sticky');
      document.querySelector('body').classList.remove('open_menu');
      document.querySelector('body').classList.remove('scroll-down');
      remove_all();
      remove_all_mobile();
      setIsMenuOpen(false);
      var _height3 = "0";
      var _opacity3 = "0";
      setIsHandleClickShanta(false);
      tl.to(".desktop-menu__bottom .mega_menu .fixed_menu .content", {
        duration: 0.5,
        opacity: _opacity3,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .fixed_menu  .social li", {
        duration: 0.5,
        opacity: _opacity3,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .content_wrap .dc-btn", {
        duration: 0.2,
        opacity: _opacity3,
        stagger: 0.09,
        ease: "power2.out"
      }, "-=0.3").to(".desktop-menu__bottom .mega_menu .content_wrap li", {
        duration: 0.3,
        opacity: _opacity3,
        stagger: 0.01,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".mega_menu"), {
        height: _height3,
        duration: 0.6,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".desktop-menu__bottom"), {
        height: _height3,
        duration: 0.3,
        ease: "power2.out"
      }, "-=0.3");
      tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
        width: '0',
        paddingLeft: '0',
        paddingRight: '0',
        opacity: '1',
        duration: 0.3,
        ease: 'power2.out',
        xPercent: '0'
      }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
        duration: 0.2,
        opacity: '0',
        x: 0,
        stagger: 0.1,
        ease: 'power2.out'
      }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
        width: '65.5%',
        duration: 0.5,
        ease: 'power2.out'
      }, "-=0.3"); // disableBodyScroll();
      // clearAllBodyScrollLocks()
      // Revert body overflow to its original value on blur

      document.body.style.overflow = 'auto';

      var _html3 = document.querySelector('html');

      _html3.style.overflow = 'auto';
    } else {
      document.querySelector('body').classList.remove('scroll-down'); // Add click event to all links

      var allLinks = document.querySelectorAll('a[href*="#"]');

      if (!allLinks.length) {
        return;
      }

      allLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          // event.preventDefault(); // Prevent the default link behavior (navigating to the href)
          var href = link.getAttribute('href');

          if (!href || !href.includes('#')) {
            return;
          }

          var targetSelector = href.slice(href.indexOf('#')); // Extract the # value from the href

          var targetElement = document.querySelector(targetSelector);

          if (targetElement) {
            setTimeout(function () {
              remove_all();
              remove_all_mobile();
              document.body.classList.remove('sticky');
              document.querySelector('body').classList.remove('open_menu');
              setIsMenuOpen(false);
              var height = "0";
              var opacity = "0";
              setIsHandleClickShanta(false);
              tl.to(".desktop-menu__bottom .mega_menu .fixed_menu .content", {
                duration: 0.5,
                opacity: opacity,
                ease: "power2.out"
              }, "-=0.5").to(".desktop-menu__bottom .mega_menu .fixed_menu  .social li", {
                duration: 0.5,
                opacity: opacity,
                ease: "power2.out"
              }, "-=0.5").to(".desktop-menu__bottom .mega_menu .content_wrap .dc-btn", {
                duration: 0.2,
                opacity: opacity,
                stagger: 0.09,
                ease: "power2.out"
              }, "-=0.3").to(".desktop-menu__bottom .mega_menu .content_wrap li", {
                duration: 0.3,
                opacity: opacity,
                stagger: 0.01,
                ease: "power2.out"
              }, "-=0.3").to(document.querySelector(".mega_menu"), {
                height: height,
                duration: 0.6,
                ease: "power2.out"
              }, "-=0.3").to(document.querySelector(".desktop-menu__bottom"), {
                height: height,
                duration: 0.3,
                ease: "power2.out"
              }, "-=0.3");
              tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
                width: '0',
                paddingLeft: '0',
                paddingRight: '0',
                opacity: '1',
                duration: 0.3,
                ease: 'power2.out',
                xPercent: '0'
              }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
                duration: 0.2,
                opacity: '0',
                x: 0,
                stagger: 0.1,
                ease: 'power2.out'
              }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
                width: '65.5%',
                duration: 0.5,
                ease: 'power2.out'
              }, "-=0.3"); // Revert body overflow to its original value on blur

              document.body.style.overflow = 'auto';
              var html = document.querySelector('html');
              html.style.overflow = 'auto'; // Use GSAP ScrollTo plugin to smoothly scroll to the target section

              gsap__WEBPACK_IMPORTED_MODULE_13__/* .gsap.to */ .p8.to(window, {
                duration: 1,
                autoKill: true,
                scrollTo: {
                  y: targetElement.offsetTop - 100
                } // Adjust the offset as needed

              });
            }, 600);
          } // if (!targetElement) {
          //     console.error(`Target element with selector '${targetSelector}' not found.`);
          //     // return;
          // }

        });
      });
      remove_all();
      remove_all_mobile();
      document.body.classList.remove('sticky');
      document.querySelector('body').classList.remove('open_menu');
      setIsMenuOpen(false);
      var _height4 = "0";
      var _opacity4 = "0";
      setIsHandleClickShanta(false);
      tl.to(".desktop-menu__bottom .mega_menu .fixed_menu .content", {
        duration: 0.5,
        opacity: _opacity4,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .fixed_menu  .social li", {
        duration: 0.5,
        opacity: _opacity4,
        ease: "power2.out"
      }, "-=0.5").to(".desktop-menu__bottom .mega_menu .content_wrap .dc-btn", {
        duration: 0.2,
        opacity: _opacity4,
        stagger: 0.09,
        ease: "power2.out"
      }, "-=0.3").to(".desktop-menu__bottom .mega_menu .content_wrap li", {
        duration: 0.3,
        opacity: _opacity4,
        stagger: 0.01,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".mega_menu"), {
        height: _height4,
        duration: 0.6,
        ease: "power2.out"
      }, "-=0.3").to(document.querySelector(".desktop-menu__bottom"), {
        height: _height4,
        duration: 0.3,
        ease: "power2.out"
      }, "-=0.3");
      tl.to(document.querySelector(".desktop-menu__bottom .mega_menu .middle-menu"), {
        width: '0',
        paddingLeft: '0',
        paddingRight: '0',
        opacity: '1',
        duration: 0.3,
        ease: 'power2.out',
        xPercent: '0'
      }, '-=0.5').to('.desktop-menu__bottom .mega_menu .middle-menu li', {
        duration: 0.2,
        opacity: '0',
        x: 0,
        stagger: 0.1,
        ease: 'power2.out'
      }, "-=0.4").to(document.querySelector(".desktop-menu__bottom .fixed_menu"), {
        width: '65.5%',
        duration: 0.5,
        ease: 'power2.out'
      }, "-=0.3"); // Revert body overflow to its original value on blur

      document.body.style.overflow = 'auto';

      var _html4 = document.querySelector('html');

      _html4.style.overflow = 'auto';
    }
  }, [location]);
  var HamburgerSVG = " <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"18\" viewBox=\"0 0 32 18\">\n                                        <g id=\"Hamburger_-_Light\" data-name=\"Hamburger - Light\"\n                                           transform=\"translate(1 1)\">\n                                            <line id=\"Line_3\" data-name=\"Line 3\" x2=\"30\" fill=\"none\" stroke=\"#fff\"\n                                                  strokeLinecap=\"round\" strokeWidth=\"2\"/>\n                                            <line id=\"Line_4\" data-name=\"Line 4\" x2=\"30\" transform=\"translate(0 8)\"\n                                                  fill=\"none\" stroke=\"#fff\" strokeLinecap=\"round\" strokeWidth=\"2\"/>\n                                            <line id=\"Line_5\" data-name=\"Line 5\" x2=\"30\" transform=\"translate(0 16)\"\n                                                  fill=\"none\" stroke=\"#fff\" strokeLinecap=\"round\" strokeWidth=\"2\"/>\n                                        </g>\n                                    </svg>\n";
  var MainLog = "<svg id=\"Group_20851\" data-name=\"Group 20851\" xmlns=\"http://www.w3.org/2000/svg\"\n                                                 width=\"201.928\" height=\"48\" viewBox=\"0 0 201.928 48\">\n                                                <defs>\n                                                    <clipPath id=\"clipPath\">\n                                                        <rect id=\"Rectangle_5879\" data-name=\"Rectangle 5879\" width=\"201.928\"\n                                                              height=\"48\" fill=\"none\"/>\n                                                    </clipPath>\n                                                </defs>\n                                                <g id=\"Group_20833\" data-name=\"Group 20833\" clipPath=\"url(#clipPath)\">\n                                                    <path id=\"Path_9363\" data-name=\"Path 9363\"\n                                                          d=\"M83.69,119.17c-.792-10.062,10.861-10.629,13.222-3.438,3.931,31.029-32.159,38.5-42.1,24.323,5.968,7.276,37,2.819,28.881-20.886\"\n                                                          transform=\"translate(-48.907 -98.953)\" fill=\"#827623\"\n                                                          fillRule=\"evenodd\"/>\n                                                    <path id=\"Path_9364\" data-name=\"Path 9364\"\n                                                          d=\"M28.633,13.64C38.611,15.091,39.941,3.49,32.922.667,2.24-5.29-7.571,30.259,5.917,41.116-.95,34.677,5.522,3.987,28.633,13.64\"\n                                                          transform=\"translate(0 0.001)\" fill=\"#827623\" fillRule=\"evenodd\"/>\n                                                    <path id=\"Path_9365\" data-name=\"Path 9365\"\n                                                          d=\"M571.687,157.529a5.779,5.779,0,0,1-2.045,4.624,7.362,7.362,0,0,1-4.885,1.632H549.32v-3.53h15.437a4.688,4.688,0,0,0,2.516-.652,2.469,2.469,0,0,0,1.215-2.163,2.318,2.318,0,0,0-1.241-2.1,4.785,4.785,0,0,0-2.491-.623h-9.542a6.728,6.728,0,0,1-4.414-1.455,5.458,5.458,0,0,1,0-8.268,6.749,6.749,0,0,1,4.414-1.455h15.256v3.526H555.215a2.694,2.694,0,0,0-1.721.567,1.827,1.827,0,0,0-.707,1.507,1.785,1.785,0,0,0,.707,1.514,2.8,2.8,0,0,0,1.721.53h9.542a7.213,7.213,0,0,1,4.885,1.691,5.867,5.867,0,0,1,2.045,4.657m23.671,6.256h-3.522v-8.422H579.951V151.84h11.885v-8.3h3.522Zm-17,0h-3.529V143.536h3.529Zm46.539,0-4.532-.033-3.4-5.659h-9.6l2.133-3.5h5.361l-3.526-5.843-9.123,15h-4.535l10.994-18.289a4.743,4.743,0,0,1,1.153-1.3,2.757,2.757,0,0,1,1.6-.682,2.608,2.608,0,0,1,1.6.652,4.756,4.756,0,0,1,1.157,1.334Zm21.895-1.75c0,1.3-.446,1.96-1.333,1.96a3.346,3.346,0,0,1-2.192-1.219l-12.976-13.042v14.052h-3.5v-18.5a2.024,2.024,0,0,1,.383-1.231,1.292,1.292,0,0,1,1.1-.519,2.951,2.951,0,0,1,2.015,1.039l12.976,13.009V143.536h3.526Zm23.016-14.972H661.84v16.723h-3.5V147.062h-8v-3.526h19.461Zm21.924,16.723-10.725-18.322a4.535,4.535,0,0,0-1.157-1.334,2.576,2.576,0,0,0-1.6-.652,2.736,2.736,0,0,0-1.6.682,4.766,4.766,0,0,0-1.157,1.3L664.5,163.751h4.535l9.123-15,3.529,5.843h-5.364l-2.133,3.5h9.6l3.4,5.659Z\"\n                                                          transform=\"translate(-489.802 -128.028)\" fill=\"#fff\"/>\n                                                    <path id=\"Path_9366\" data-name=\"Path 9366\"\n                                                          d=\"M557.664,368.175l-.74.458a1.6,1.6,0,0,0-1.437-.873,1.443,1.443,0,0,0-.973.351,1.127,1.127,0,0,0-.409.894.922.922,0,0,0,.11.447,1.029,1.029,0,0,0,.343.356c.155.1.286.183.393.24s.259.128.459.213l.552.235a7.691,7.691,0,0,1,.785.378,3.928,3.928,0,0,1,.613.437,1.639,1.639,0,0,1,.453.622,2.15,2.15,0,0,1,.149.82,2.327,2.327,0,0,1-.763,1.762,2.782,2.782,0,0,1-3.553.149,2.554,2.554,0,0,1-.9-1.506l.906-.245a1.734,1.734,0,0,0,.552,1.06,1.582,1.582,0,0,0,1.117.431,1.757,1.757,0,0,0,1.2-.453,1.425,1.425,0,0,0,.514-1.113,1.3,1.3,0,0,0-.093-.495,1.388,1.388,0,0,0-.211-.367,1.562,1.562,0,0,0-.37-.3c-.169-.107-.3-.183-.4-.229s-.251-.115-.464-.207l-.508-.213a4.556,4.556,0,0,1-1.348-.83,1.621,1.621,0,0,1-.464-1.225,1.826,1.826,0,0,1,.685-1.474,2.641,2.641,0,0,1,2.908-.245,2.369,2.369,0,0,1,.895.921\"\n                                                          transform=\"translate(-493.227 -327.419)\" fill=\"#fff\"/>\n                                                    <path id=\"Path_9367\" data-name=\"Path 9367\"\n                                                          d=\"M703.839,375.232v-8.3h4.322v.859h-3.393v2.467h3.293v.859h-3.293v3.26h3.393v.859Z\"\n                                                          transform=\"translate(-628.051 -327.418)\" fill=\"#fff\"/>\n                                                    <path id=\"Path_9368\" data-name=\"Path 9368\"\n                                                          d=\"M851.087,367.717v1.107a3.487,3.487,0,0,0-2.542-1.064,3.23,3.23,0,0,0-2.371.99,3.235,3.235,0,0,0,.005,4.663,3.263,3.263,0,0,0,2.387.99,3.534,3.534,0,0,0,2.52-1.065v1.107a4.249,4.249,0,0,1-2.487.788,4.315,4.315,0,0,1-3.056-1.209,3.849,3.849,0,0,1-1.288-2.911,3.956,3.956,0,0,1,1.277-2.954,4.264,4.264,0,0,1,3.067-1.23,4.151,4.151,0,0,1,2.487.788\"\n                                                          transform=\"translate(-753.348 -327.419)\" fill=\"#fff\"/>\n                                                    <path id=\"Path_9369\" data-name=\"Path 9369\"\n                                                          d=\"M1013.01,366.929v4.861q0,.466.005.66a2.924,2.924,0,0,0,.094.557,1.645,1.645,0,0,0,.266.6,1.814,1.814,0,0,0,.735.568,2.287,2.287,0,0,0,.945.212,2.253,2.253,0,0,0,.9-.195,2,2,0,0,0,.735-.531,1.567,1.567,0,0,0,.288-.557,2.416,2.416,0,0,0,.111-.552c.007-.148.011-.36.011-.633v-4.991h.928v5.11a5.048,5.048,0,0,1-.137,1.288,2.262,2.262,0,0,1-.592.974,2.961,2.961,0,0,1-2.243.931,3,3,0,0,1-2.155-.834,2.267,2.267,0,0,1-.658-1.007,4.836,4.836,0,0,1-.16-1.354v-5.11Z\"\n                                                          transform=\"translate(-903.103 -327.419)\" fill=\"#fff\"/>\n                                                    <path id=\"Path_9370\" data-name=\"Path 9370\"\n                                                          d=\"M1173.548,371.587v3.645h-.929v-8.3h1.2a5.989,5.989,0,0,1,1.15.1,3.4,3.4,0,0,1,.962.341,1.643,1.643,0,0,1,.7.71,2.448,2.448,0,0,1,.243,1.14,2.282,2.282,0,0,1-.563,1.585,2.194,2.194,0,0,1-1.525.706l2.653,3.722H1176.3l-2.52-3.645Zm0-3.8v2.984h.287a4.917,4.917,0,0,0,.779-.055,2.618,2.618,0,0,0,.663-.2,1.06,1.06,0,0,0,.5-.457,1.581,1.581,0,0,0,.171-.771,1.7,1.7,0,0,0-.122-.677,1.24,1.24,0,0,0-.3-.44,1.207,1.207,0,0,0-.475-.248,2.859,2.859,0,0,0-.57-.109c-.181-.015-.4-.023-.658-.023Z\"\n                                                          transform=\"translate(-1046.354 -327.419)\" fill=\"#fff\"/>\n                                                    <rect id=\"Rectangle_5877\" data-name=\"Rectangle 5877\" width=\"0.929\"\n                                                          height=\"8.304\" transform=\"translate(141.97 39.51)\" fill=\"#fff\"/>\n                                                    <path id=\"Path_9371\" data-name=\"Path 9371\"\n                                                          d=\"M1428.991,367.788v7.445h-.928v-7.445h-2.011v-.859h4.973v.859Z\"\n                                                          transform=\"translate(-1272.498 -327.419)\" fill=\"#fff\"/>\n                                                    <rect id=\"Rectangle_5878\" data-name=\"Rectangle 5878\" width=\"0.929\"\n                                                          height=\"8.304\" transform=\"translate(169.193 39.51)\" fill=\"#fff\"/>\n                                                    <path id=\"Path_9372\" data-name=\"Path 9372\"\n                                                          d=\"M1685.635,375.232v-8.3h4.322v.859h-3.393v2.467h3.293v.859h-3.293v3.26h3.393v.859Z\"\n                                                          transform=\"translate(-1504.13 -327.418)\" fill=\"#fff\"/>\n                                                    <path id=\"Path_9373\" data-name=\"Path 9373\"\n                                                          d=\"M1831.694,368.175l-.74.458a1.6,1.6,0,0,0-1.437-.873,1.443,1.443,0,0,0-.973.351,1.127,1.127,0,0,0-.408.894.922.922,0,0,0,.11.447,1.031,1.031,0,0,0,.343.356c.155.1.286.183.393.24s.259.128.459.213l.552.235a7.683,7.683,0,0,1,.785.378,3.925,3.925,0,0,1,.613.437,1.639,1.639,0,0,1,.453.622,2.152,2.152,0,0,1,.149.82,2.327,2.327,0,0,1-.763,1.762,2.782,2.782,0,0,1-3.553.149,2.555,2.555,0,0,1-.9-1.506l.906-.245a1.734,1.734,0,0,0,.552,1.06,1.582,1.582,0,0,0,1.117.431,1.758,1.758,0,0,0,1.2-.453,1.425,1.425,0,0,0,.514-1.113,1.3,1.3,0,0,0-.094-.495,1.383,1.383,0,0,0-.211-.367,1.561,1.561,0,0,0-.37-.3c-.169-.107-.3-.183-.4-.229s-.251-.115-.464-.207l-.508-.213a4.556,4.556,0,0,1-1.349-.83,1.621,1.621,0,0,1-.464-1.225,1.826,1.826,0,0,1,.685-1.474,2.641,2.641,0,0,1,2.908-.245,2.369,2.369,0,0,1,.895.921\"\n                                                          transform=\"translate(-1630.073 -327.419)\" fill=\"#fff\"/>\n                                                </g>\n                                            </svg>\n                                      ";
  var StickyLogo = "   <svg id=\"Group_20832\" data-name=\"Group 20832\" xmlns=\"http://www.w3.org/2000/svg\"\n                                                 width=\"201.928\" height=\"48\" viewBox=\"0 0 201.928 48\">\n                                                <defs>\n                                                    <clipPath id=\"clipPath\">\n                                                        <rect id=\"Rectangle_5876\" data-name=\"Rectangle 5876\" width=\"201.928\"\n                                                              height=\"48\" fill=\"none\"/>\n                                                    </clipPath>\n                                                </defs>\n                                                <g id=\"Group_20831\" data-name=\"Group 20831\" clipPath=\"url(#clipPath)\">\n                                                    <path id=\"Path_9352\" data-name=\"Path 9352\"\n                                                          d=\"M83.69,119.17c-.792-10.062,10.861-10.629,13.222-3.438,3.931,31.029-32.159,38.5-42.1,24.323,5.968,7.276,37,2.819,28.881-20.886\"\n                                                          transform=\"translate(-48.907 -98.953)\" fill=\"#827623\"\n                                                          fillRule=\"evenodd\"/>\n                                                    <path id=\"Path_9353\" data-name=\"Path 9353\"\n                                                          d=\"M28.633,13.64C38.611,15.091,39.941,3.49,32.922.667,2.24-5.29-7.571,30.259,5.917,41.116-.95,34.677,5.522,3.987,28.633,13.64\"\n                                                          transform=\"translate(0 0.001)\" fill=\"#827623\" fillRule=\"evenodd\"/>\n                                                    <path id=\"Path_9354\" data-name=\"Path 9354\"\n                                                          d=\"M571.687,157.529a5.779,5.779,0,0,1-2.045,4.624,7.362,7.362,0,0,1-4.885,1.632H549.32v-3.53h15.437a4.688,4.688,0,0,0,2.516-.652,2.469,2.469,0,0,0,1.215-2.163,2.318,2.318,0,0,0-1.241-2.1,4.785,4.785,0,0,0-2.491-.623h-9.542a6.728,6.728,0,0,1-4.414-1.455,5.458,5.458,0,0,1,0-8.268,6.749,6.749,0,0,1,4.414-1.455h15.256v3.526H555.215a2.694,2.694,0,0,0-1.721.567,1.827,1.827,0,0,0-.707,1.507,1.785,1.785,0,0,0,.707,1.514,2.8,2.8,0,0,0,1.721.53h9.542a7.213,7.213,0,0,1,4.885,1.691,5.867,5.867,0,0,1,2.045,4.657m23.671,6.256h-3.522v-8.422H579.951V151.84h11.885v-8.3h3.522Zm-17,0h-3.529V143.536h3.529Zm46.539,0-4.532-.033-3.4-5.659h-9.6l2.133-3.5h5.361l-3.526-5.843-9.123,15h-4.535l10.994-18.289a4.743,4.743,0,0,1,1.153-1.3,2.757,2.757,0,0,1,1.6-.682,2.608,2.608,0,0,1,1.6.652,4.756,4.756,0,0,1,1.157,1.334Zm21.895-1.75c0,1.3-.446,1.96-1.333,1.96a3.346,3.346,0,0,1-2.192-1.219l-12.976-13.042v14.052h-3.5v-18.5a2.024,2.024,0,0,1,.383-1.231,1.292,1.292,0,0,1,1.1-.519,2.951,2.951,0,0,1,2.015,1.039l12.976,13.009V143.536h3.526Zm23.016-14.972H661.84v16.723h-3.5V147.062h-8v-3.526h19.461Zm21.924,16.723-10.725-18.322a4.535,4.535,0,0,0-1.157-1.334,2.576,2.576,0,0,0-1.6-.652,2.736,2.736,0,0,0-1.6.682,4.766,4.766,0,0,0-1.157,1.3L664.5,163.751h4.535l9.123-15,3.529,5.843h-5.364l-2.133,3.5h9.6l3.4,5.659Z\"\n                                                          transform=\"translate(-489.802 -128.028)\" fill=\"#313133\"/>\n                                                    <path id=\"Path_9355\" data-name=\"Path 9355\"\n                                                          d=\"M557.664,368.175l-.74.458a1.6,1.6,0,0,0-1.437-.873,1.443,1.443,0,0,0-.973.351,1.127,1.127,0,0,0-.409.894.922.922,0,0,0,.11.447,1.029,1.029,0,0,0,.343.356c.155.1.286.183.393.24s.259.128.459.213l.552.235a7.691,7.691,0,0,1,.785.378,3.928,3.928,0,0,1,.613.437,1.639,1.639,0,0,1,.453.622,2.15,2.15,0,0,1,.149.82,2.327,2.327,0,0,1-.763,1.762,2.782,2.782,0,0,1-3.553.149,2.554,2.554,0,0,1-.9-1.506l.906-.245a1.734,1.734,0,0,0,.552,1.06,1.582,1.582,0,0,0,1.117.431,1.757,1.757,0,0,0,1.2-.453,1.425,1.425,0,0,0,.514-1.113,1.3,1.3,0,0,0-.093-.495,1.388,1.388,0,0,0-.211-.367,1.562,1.562,0,0,0-.37-.3c-.169-.107-.3-.183-.4-.229s-.251-.115-.464-.207l-.508-.213a4.556,4.556,0,0,1-1.348-.83,1.621,1.621,0,0,1-.464-1.225,1.826,1.826,0,0,1,.685-1.474,2.641,2.641,0,0,1,2.908-.245,2.369,2.369,0,0,1,.895.921\"\n                                                          transform=\"translate(-493.227 -327.419)\" fill=\"#313133\"/>\n                                                    <path id=\"Path_9356\" data-name=\"Path 9356\"\n                                                          d=\"M703.839,375.232v-8.3h4.322v.859h-3.393v2.467h3.293v.859h-3.293v3.26h3.393v.859Z\"\n                                                          transform=\"translate(-628.051 -327.418)\" fill=\"#313133\"/>\n                                                    <path id=\"Path_9357\" data-name=\"Path 9357\"\n                                                          d=\"M851.087,367.717v1.107a3.487,3.487,0,0,0-2.542-1.064,3.23,3.23,0,0,0-2.371.99,3.235,3.235,0,0,0,.005,4.663,3.263,3.263,0,0,0,2.387.99,3.534,3.534,0,0,0,2.52-1.065v1.107a4.249,4.249,0,0,1-2.487.788,4.315,4.315,0,0,1-3.056-1.209,3.849,3.849,0,0,1-1.288-2.911,3.956,3.956,0,0,1,1.277-2.954,4.264,4.264,0,0,1,3.067-1.23,4.151,4.151,0,0,1,2.487.788\"\n                                                          transform=\"translate(-753.348 -327.419)\" fill=\"#313133\"/>\n                                                    <path id=\"Path_9358\" data-name=\"Path 9358\"\n                                                          d=\"M1013.01,366.929v4.861q0,.466.005.66a2.924,2.924,0,0,0,.094.557,1.645,1.645,0,0,0,.266.6,1.814,1.814,0,0,0,.735.568,2.287,2.287,0,0,0,.945.212,2.253,2.253,0,0,0,.9-.195,2,2,0,0,0,.735-.531,1.567,1.567,0,0,0,.288-.557,2.416,2.416,0,0,0,.111-.552c.007-.148.011-.36.011-.633v-4.991h.928v5.11a5.048,5.048,0,0,1-.137,1.288,2.262,2.262,0,0,1-.592.974,2.961,2.961,0,0,1-2.243.931,3,3,0,0,1-2.155-.834,2.267,2.267,0,0,1-.658-1.007,4.836,4.836,0,0,1-.16-1.354v-5.11Z\"\n                                                          transform=\"translate(-903.103 -327.419)\" fill=\"#313133\"/>\n                                                    <path id=\"Path_9359\" data-name=\"Path 9359\"\n                                                          d=\"M1173.548,371.587v3.645h-.929v-8.3h1.2a5.989,5.989,0,0,1,1.15.1,3.4,3.4,0,0,1,.962.341,1.643,1.643,0,0,1,.7.71,2.448,2.448,0,0,1,.243,1.14,2.282,2.282,0,0,1-.563,1.585,2.194,2.194,0,0,1-1.525.706l2.653,3.722H1176.3l-2.52-3.645Zm0-3.8v2.984h.287a4.917,4.917,0,0,0,.779-.055,2.618,2.618,0,0,0,.663-.2,1.06,1.06,0,0,0,.5-.457,1.581,1.581,0,0,0,.171-.771,1.7,1.7,0,0,0-.122-.677,1.24,1.24,0,0,0-.3-.44,1.207,1.207,0,0,0-.475-.248,2.859,2.859,0,0,0-.57-.109c-.181-.015-.4-.023-.658-.023Z\"\n                                                          transform=\"translate(-1046.354 -327.419)\" fill=\"#313133\"/>\n                                                    <rect id=\"Rectangle_5874\" data-name=\"Rectangle 5874\" width=\"0.929\"\n                                                          height=\"8.304\" transform=\"translate(141.97 39.51)\" fill=\"#313133\"/>\n                                                    <path id=\"Path_9360\" data-name=\"Path 9360\"\n                                                          d=\"M1428.991,367.788v7.445h-.928v-7.445h-2.011v-.859h4.973v.859Z\"\n                                                          transform=\"translate(-1272.498 -327.419)\" fill=\"#313133\"/>\n                                                    <rect id=\"Rectangle_5875\" data-name=\"Rectangle 5875\" width=\"0.929\"\n                                                          height=\"8.304\" transform=\"translate(169.193 39.51)\" fill=\"#313133\"/>\n                                                    <path id=\"Path_9361\" data-name=\"Path 9361\"\n                                                          d=\"M1685.635,375.232v-8.3h4.322v.859h-3.393v2.467h3.293v.859h-3.293v3.26h3.393v.859Z\"\n                                                          transform=\"translate(-1504.13 -327.418)\" fill=\"#313133\"/>\n                                                    <path id=\"Path_9362\" data-name=\"Path 9362\"\n                                                          d=\"M1831.694,368.175l-.74.458a1.6,1.6,0,0,0-1.437-.873,1.443,1.443,0,0,0-.973.351,1.127,1.127,0,0,0-.408.894.922.922,0,0,0,.11.447,1.031,1.031,0,0,0,.343.356c.155.1.286.183.393.24s.259.128.459.213l.552.235a7.683,7.683,0,0,1,.785.378,3.925,3.925,0,0,1,.613.437,1.639,1.639,0,0,1,.453.622,2.152,2.152,0,0,1,.149.82,2.327,2.327,0,0,1-.763,1.762,2.782,2.782,0,0,1-3.553.149,2.555,2.555,0,0,1-.9-1.506l.906-.245a1.734,1.734,0,0,0,.552,1.06,1.582,1.582,0,0,0,1.117.431,1.758,1.758,0,0,0,1.2-.453,1.425,1.425,0,0,0,.514-1.113,1.3,1.3,0,0,0-.094-.495,1.383,1.383,0,0,0-.211-.367,1.561,1.561,0,0,0-.37-.3c-.169-.107-.3-.183-.4-.229s-.251-.115-.464-.207l-.508-.213a4.556,4.556,0,0,1-1.349-.83,1.621,1.621,0,0,1-.464-1.225,1.826,1.826,0,0,1,.685-1.474,2.641,2.641,0,0,1,2.908-.245,2.369,2.369,0,0,1,.895.921\"\n                                                          transform=\"translate(-1630.073 -327.419)\" fill=\"#313133\"/>\n                                                </g>\n                                            </svg>\n";
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var desktopHamburgerHover = document.querySelector('.burger-click');
    var svgLine4 = document.querySelector('svg #Line_4');
    var svgLine5 = document.querySelector('svg #Line_5');

    var handleMouseOver = function handleMouseOver() {
      if (desktopHamburgerHover.classList.contains('close')) {
        svgLine4.style.strokeDasharray = '30px';
        svgLine5.style.strokeDasharray = '30px';
      } else {
        svgLine4.style.strokeDasharray = '20px';
        svgLine5.style.strokeDasharray = '15px';
      }
    };

    var handleMouseOut = function handleMouseOut() {
      svgLine4.style.strokeDasharray = '30px';
      svgLine5.style.strokeDasharray = '30px';
    };

    desktopHamburgerHover.addEventListener('mouseover', handleMouseOver);
    desktopHamburgerHover.addEventListener('mouseout', handleMouseOut);
  }, []);
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();

  var handleLogoClick = function handleLogoClick() {
    router.push('/'); // Change the route to '/'
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(StyledDesktopMenu, {
    className: "desktop-menu ",
    offset: offset,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "overlay ".concat(showSubmenu ? 'sub-menu-open ' : null)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      ref: headerRef,
      offset: offset,
      id: 'menu',
      className: "desktop-menu",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_outside_click_handler__WEBPACK_IMPORTED_MODULE_2__["default"], {
        onOutsideClick: function onOutsideClick() {
          remove_all();
          remove_search();
          document.body.classList.remove('menu-open');
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            className: "desktop-menu__top",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              className: "desktop-menu__top__logo main_logo",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "desktop-hamburger",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                  ref: hamburgerDesktopRef,
                  onClick: handleHamburgerClick,
                  id: 'hamburger-desktop',
                  className: "".concat(isMenuOpen ? "close" : "", " burger-click"),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                      __html: HamburgerSVG
                    }
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "normal_logo",
                style: {
                  cursor: 'pointer'
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                  onClick: handleLogoClick,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                    src: "/images/static/logo.svg",
                    alt: 'Shanta Securities Limited'
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "sticky_logo",
                style: {
                  cursor: 'pointer'
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                  onClick: handleLogoClick,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                    src: "/images/static/logo_dark.svg",
                    alt: 'Shanta Securities Limited'
                  })
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("ul", {
                className: "d-flex justify-content-end",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  className: "call hover",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                    href: "tel:+8801313778778",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("svg", {
                      id: "Button_-_Hotline_-_Light",
                      "data-name": "Button - Hotline - Light",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "170",
                      height: "44",
                      viewBox: "0 0 170 44",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                        id: "Rectangle_492",
                        "data-name": "Rectangle 492",
                        fill: "none",
                        stroke: "#fff",
                        "stroke-width": "1",
                        opacity: "0.3",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("rect", {
                          width: "120",
                          height: "44",
                          rx: "22",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "169",
                          height: "43",
                          rx: "21.5",
                          fill: "none"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                        id: "Rectangle_493",
                        "data-name": "Rectangle 493",
                        fill: "none",
                        stroke: "#fff",
                        "stroke-width": "2",
                        strokeDasharray: "1 520",
                        opacity: "0",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("rect", {
                          width: "120",
                          height: "44",
                          rx: "22",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "169",
                          height: "43",
                          rx: "21.5",
                          fill: "none"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                        id: "Group_4811",
                        "data-name": "Group 4811",
                        transform: "translate(-791 -27)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("text", {
                          id: "_16634",
                          "data-name": "16634",
                          transform: "translate(843 54)",
                          fill: "#fff",
                          "font-size": "16",
                          "font-family": "Avenir-Medium, Avenir",
                          "font-weight": "500",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("tspan", {
                            x: "0",
                            y: "0",
                            children: "01313778778"
                          })
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("path", {
                          id: "Path_8647",
                          "data-name": "Path 8647",
                          d: "M4.965,13.295a21.287,21.287,0,0,0,7.084,5.528,11.057,11.057,0,0,0,3.964,1.169c.1,0,.187.008.283.008a3.289,3.289,0,0,0,2.546-1.09.09.09,0,0,0,.017-.021,10.7,10.7,0,0,1,.8-.829c.2-.186.4-.381.587-.58a2,2,0,0,0-.008-2.98l-2.5-2.491a2.027,2.027,0,0,0-1.464-.671,2.1,2.1,0,0,0-1.481.667l-1.489,1.484c-.137-.079-.279-.149-.412-.215a5.15,5.15,0,0,1-.458-.249A15.74,15.74,0,0,1,8.671,9.61,9.037,9.037,0,0,1,7.4,7.588c.391-.352.757-.721,1.111-1.082.125-.128.254-.257.383-.385a2.121,2.121,0,0,0,.691-1.492,2.1,2.1,0,0,0-.691-1.492L7.652,1.9c-.146-.145-.283-.286-.424-.431C6.953,1.189,6.666.9,6.383.638A2.078,2.078,0,0,0,4.919,0,2.139,2.139,0,0,0,3.438.642L1.882,2.192A3.179,3.179,0,0,0,.929,4.231a7.644,7.644,0,0,0,.578,3.315A19.273,19.273,0,0,0,4.965,13.295ZM1.944,4.318a2.189,2.189,0,0,1,.661-1.409L4.153,1.368a1.122,1.122,0,0,1,.765-.352,1.065,1.065,0,0,1,.749.361c.279.257.541.526.824.812.141.145.287.29.433.439l1.24,1.235a1.124,1.124,0,0,1,.391.775,1.124,1.124,0,0,1-.391.775c-.129.128-.258.261-.387.39-.387.39-.749.758-1.148,1.111l-.021.021a.808.808,0,0,0-.208.92c0,.012.008.021.012.033a9.747,9.747,0,0,0,1.46,2.366,16.613,16.613,0,0,0,4.01,3.639,5.961,5.961,0,0,0,.549.3,5.15,5.15,0,0,1,.458.249l.046.025a.872.872,0,0,0,.4.1.884.884,0,0,0,.62-.282l1.556-1.55a1.1,1.1,0,0,1,.761-.369,1.046,1.046,0,0,1,.736.369L19.52,15.23a1,1,0,0,1-.012,1.562c-.175.186-.358.365-.553.551a11.955,11.955,0,0,0-.869.9A2.288,2.288,0,0,1,16.3,19c-.071,0-.146,0-.216-.008A14.208,14.208,0,0,1,12.5,17.92S7.639,14.9,5.755,12.656a18.448,18.448,0,0,1-3.286-5.45A6.662,6.662,0,0,1,1.944,4.318Z",
                          transform: "translate(814.089 39)",
                          fill: "#fff"
                        })]
                      })]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  className: "call dc-btn",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                    href: 'https://portal.shantasecurities.com/signup',
                    target: '_blank',
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                      children: "Open an Account"
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  className: "hover ",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    ref: searchClickRef,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("svg", {
                      id: "Button_-_Search_-_Light",
                      "data-name": "Button - Search - Light",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "44",
                      height: "44",
                      viewBox: "0 0 44 44",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                        id: "Ellipse_18",
                        "data-name": "Ellipse 18",
                        fill: "none",
                        stroke: "#fff",
                        "stroke-width": "1",
                        opacity: "0.3",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                          cx: "22",
                          cy: "22",
                          r: "22",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                          cx: "22",
                          cy: "22",
                          r: "21.5",
                          fill: "none"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                        id: "Ellipse_19",
                        "data-name": "Ellipse 19",
                        fill: "none",
                        stroke: "#fff",
                        "stroke-width": "2",
                        strokeDasharray: "0 142",
                        opacity: "0",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                          cx: "22",
                          cy: "22",
                          r: "22",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                          cx: "22",
                          cy: "22",
                          r: "21.5",
                          fill: "none"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("g", {
                        id: "search",
                        transform: "translate(12.804 13)",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("path", {
                          id: "Path_8648",
                          "data-name": "Path 8648",
                          d: "M7.614,14.825a7.412,7.412,0,1,1,7.418-7.412,7.424,7.424,0,0,1-7.418,7.412Zm0-13.419a6.007,6.007,0,1,0,6.012,6.007A6.016,6.016,0,0,0,7.614,1.405ZM17.99,17.794a.7.7,0,0,0,0-.994l-3.146-3.144a.7.7,0,0,0-.994.994L17,17.794a.7.7,0,0,0,.994,0Z",
                          transform: "translate(0 0)",
                          fill: "#fff"
                        })
                      })]
                    })
                  })
                })]
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            className: "desktop-menu__bottom",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: 'mega_menu submenu',
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: "content_wrap",
                style: {
                  paddingLeft: offset - 15 + 'px'
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  onClick: function onClick(event) {
                    return handleclickshanta(1, event);
                  },
                  className: "has-child-sub ".concat(activehanta == true ? 'active' : ''),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                    children: ["Shanta Securities Limited", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  onMouseLeave: handleMouseLeave,
                  onMouseEnter: function onMouseEnter() {
                    return handleMouseEnter('services');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    prefetch: true,
                    href: "/our-services",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      children: ["Our Services", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  onMouseLeave: handleMouseLeave,
                  onMouseEnter: function onMouseEnter() {
                    return handleMouseEnter('research');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    prefetch: true,
                    href: "/research",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      children: ["Research Center", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  onMouseLeave: handleMouseLeave,
                  onMouseEnter: function onMouseEnter() {
                    return handleMouseEnter('invest');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    prefetch: true,
                    href: "/investment-calculator",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      children: [" Investment Calculator", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  onMouseLeave: handleMouseLeave,
                  onMouseEnter: function onMouseEnter() {
                    return handleMouseEnter('career');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    prefetch: true,
                    href: "/career",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      children: ["Career", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  onMouseLeave: handleMouseLeave,
                  onMouseEnter: function onMouseEnter() {
                    return handleMouseEnter('news');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    prefetch: true,
                    href: "/news",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      children: ["News", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  onMouseLeave: handleMouseLeave,
                  onMouseEnter: function onMouseEnter() {
                    return handleMouseEnter('contact');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    prefetch: true,
                    href: "/contact",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      children: ["Contact", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  className: '',
                  onMouseLeave: handleMouseLeave,
                  onMouseEnter: function onMouseEnter() {
                    return handleMouseEnter('downloads');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    prefetch: true,
                    href: "/downloads",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      children: ["Downloads", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                  className: 'last',
                  onMouseLeave: handleMouseLeave,
                  onMouseEnter: function onMouseEnter() {
                    return handleMouseEnter('downloads');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    prefetch: true,
                    href: "/campaign",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      children: ["Campaign", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                  className: "",
                  onClick: function onClick() {
                    return handleMouseEnter('subscribe');
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    border: '0',
                    margin: '40px 0 0',
                    padding: '0',
                    borderColor: 'transparent',
                    width: '100%',
                    text: 'Subscribe to Newsletter',
                    color: '#FFFFFF',
                    hoverBackground: _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__/* .hover */ .Mr,
                    background: '#C6C6C6'
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                  src: 'easytrade',
                  margin: '20px 0 0',
                  padding: '0',
                  width: '100%',
                  text: 'Shanta EasyTrade',
                  color: '#FFFFFF',
                  hoverBackground: '#3C3C3B',
                  background: '#978C21'
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "middle-menu",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "shanta",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                    onMouseLeave: handleMouseLeave,
                    onMouseEnter: function onMouseEnter() {
                      return handleMouseEnter('who');
                    },
                    className: "",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                      prefetch: true,
                      href: "/about",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                        children: ["Who We Are", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                    onMouseLeave: handleMouseLeave,
                    onMouseEnter: function onMouseEnter() {
                      return handleMouseEnter('mission');
                    },
                    className: "",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                      prefetch: true,
                      href: "/about#mission-vision",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                        children: ["Our Mission and Vision", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                    onMouseLeave: handleMouseLeave,
                    onMouseEnter: function onMouseEnter() {
                      return handleMouseEnter('core');
                    },
                    className: "",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                      prefetch: true,
                      href: "/about#core-values",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                        children: ["Our Core Values", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                    onMouseLeave: handleMouseLeave,
                    onMouseEnter: function onMouseEnter() {
                      return handleMouseEnter('directors');
                    },
                    className: "",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                      prefetch: true,
                      href: "/about#our-board",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                        children: ["Our Board", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                    onMouseLeave: handleMouseLeave,
                    onMouseEnter: function onMouseEnter() {
                      return handleMouseEnter('experts');
                    },
                    className: "",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                      prefetch: true,
                      href: "/about#our-team",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                        children: ["Our Team", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsChevronRight */ .fmn, {})]
                      })
                    })
                  })]
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: "fixed_menu",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'all' ? 'visible' : 'hidden', " "),
                  "data-tab": 'all',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: "content",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("h3", {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        children: "Shanta Securities Limited"
                      }), " is one of the top", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), " brokerage houses in Bangladesh with Innovative Financial", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), " Services and Capital Market Solutions."]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                      children: "Call"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                      className: "all",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                        href: "tel:+88 02 226601684",
                        children: "+88 02 226601684"
                      }), ",", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                        href: "tel:+88 02 226601685",
                        children: "+88 02 226601685"
                      }), ",", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                        href: "tel:+88 02 226601688",
                        children: "+88 02 226601688"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                      children: "Visit"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
                      target: '_blank',
                      href: 'https://www.google.com/maps/search/The+Glass+House++(Level-10,+Eastern+Side),++S.E+(B)-2,+38,+Gulshan+Avenue,++Gulshan-1,+Dhaka-1212/@23.7809179,90.414273,17z/data=!3m1!4b1?entry=ttu',
                      children: ["The Glass House ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), "(Level-10, Eastern Side),", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), "S.E (B)-2, 38, Gulshan Avenue,", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), "Gulshan-1, Dhaka-1212"]
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("ul", {
                    className: "social ",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                        href: 'https://www.facebook.com/shantasecurities/',
                        target: '_blank',
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 30 30",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                            id: "Group_19435",
                            "data-name": "Group 19435",
                            transform: "translate(15536 -9208)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                              id: "Ellipse_602",
                              "data-name": "Ellipse 602",
                              cx: "15",
                              cy: "15",
                              r: "14",
                              transform: "translate(-15536 9208)",
                              fill: "none",
                              stroke: "#978C21",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                              id: "Ellipse_603",
                              "data-name": "Ellipse 603",
                              cx: "15",
                              cy: "50",
                              r: "15",
                              transform: "translate(-15536 9208)",
                              fill: "#978c21"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("path", {
                              id: "Path_2115",
                              "data-name": "Path 2115",
                              d: "M1206.12,104.34l.406-2.652h-2.544v-1.72a1.325,1.325,0,0,1,1.495-1.432h1.157V96.278a14.1,14.1,0,0,0-2.053-.179,3.237,3.237,0,0,0-3.465,3.569v2.021h-2.329v2.652h2.329v6.409h2.866V104.34Z",
                              transform: "translate(-16723.787 9119.901)",
                              fill: "#978c21"
                            })]
                          })
                        })
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                        href: 'https://www.instagram.com/shantasecurities/',
                        target: '_blank',
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 30 30",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                            id: "Group_19435",
                            "data-name": "Group 19435",
                            transform: "translate(15536 -9208)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                              id: "Ellipse_602",
                              "data-name": "Ellipse 602",
                              cx: "15",
                              cy: "15",
                              r: "14",
                              transform: "translate(-15536 9208)",
                              fill: "none",
                              stroke: "#978C21",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                              id: "Ellipse_603",
                              "data-name": "Ellipse 603",
                              cx: "15",
                              cy: "50",
                              r: "15",
                              transform: "translate(-15536 9208)",
                              fill: "#978c21"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                            id: "Group_1419",
                            "data-name": "Group 1419",
                            transform: "translate(8 8)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("path", {
                              id: "Path_2109",
                              "data-name": "Path 2109",
                              d: "M1095.77,105.945a.854.854,0,1,0,.853.854A.854.854,0,0,0,1095.77,105.945Z",
                              transform: "translate(-1084.635 -103.346)",
                              fill: "#978C21"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("path", {
                              id: "Path_2110",
                              "data-name": "Path 2110",
                              d: "M1082.64,108.605a3.586,3.586,0,1,0,3.586,3.586A3.59,3.59,0,0,0,1082.64,108.605Zm0,5.882a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,1082.64,114.488Z",
                              transform: "translate(-1075.301 -104.911)",
                              fill: "#978C21"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("path", {
                              id: "Path_2111",
                              "data-name": "Path 2111",
                              d: "M1080.119,114.188h-5.813a4.379,4.379,0,0,1-4.374-4.374V104a4.378,4.378,0,0,1,4.374-4.373h5.813a4.378,4.378,0,0,1,4.374,4.373v5.813A4.379,4.379,0,0,1,1080.119,114.188ZM1074.306,101a3.007,3.007,0,0,0-3,3v5.813a3.007,3.007,0,0,0,3,3h5.813a3.007,3.007,0,0,0,3-3V104a3.007,3.007,0,0,0-3-3Z",
                              transform: "translate(-1069.932 -99.628)",
                              fill: "#978c21"
                            })]
                          })]
                        })
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                        href: 'https://www.linkedin.com/company/74940628/admin/feed/posts/',
                        target: '_blank',
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 30 30",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                            id: "Group_19435",
                            "data-name": "Group 19435",
                            transform: "translate(15536 -9208)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                              id: "Ellipse_602",
                              "data-name": "Ellipse 602",
                              cx: "15",
                              cy: "15",
                              r: "14",
                              transform: "translate(-15536 9208)",
                              fill: "none",
                              stroke: "#978C21",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                              id: "Ellipse_603",
                              "data-name": "Ellipse 603",
                              cx: "15",
                              cy: "50",
                              r: "15",
                              transform: "translate(-15536 9208)",
                              fill: "#978c21"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("g", {
                            id: "linkedin-logotype",
                            transform: "translate(8 8)",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("path", {
                              id: "Path_8798",
                              "data-name": "Path 8798",
                              d: "M1.456,1.211a1.121,1.121,0,0,1,.875.351,1.355,1.355,0,0,1,.34.881,1.2,1.2,0,0,1-.358.881,1.329,1.329,0,0,1-.98.358H1.317a1.3,1.3,0,0,1-.962-.358A1.208,1.208,0,0,1,0,2.442a1.128,1.128,0,0,1,.391-.884A1.552,1.552,0,0,1,1.456,1.211ZM.156,4.659H2.71v7.173H.156ZM11.943,7.72v4.113H9.39V8a2.076,2.076,0,0,0-.3-1.177,1.114,1.114,0,0,0-1-.443,1.279,1.279,0,0,0-.858.273,1.632,1.632,0,0,0-.463.6,1.044,1.044,0,0,0-.06.265,3.071,3.071,0,0,0-.014.31v4.008H4.126q.016-1.821.017-3.337V6.062c0-.353,0-.654-.01-.9s-.007-.415-.007-.5H6.7V5.675L6.681,5.7H6.7V5.675A2.953,2.953,0,0,1,7,5.283a2.346,2.346,0,0,1,.46-.382,2.622,2.622,0,0,1,.656-.291A3.1,3.1,0,0,1,9,4.5a3.494,3.494,0,0,1,1.166.19,2.392,2.392,0,0,1,.935.6,2.848,2.848,0,0,1,.617,1.007A4.105,4.105,0,0,1,11.943,7.72Z",
                              transform: "translate(0)",
                              fill: "#978C21"
                            })
                          })]
                        })
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                        href: 'https://www.youtube.com/@shantasecurities4260',
                        target: '_blank',
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 30 30",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("g", {
                            id: "Group_19435",
                            "data-name": "Group 19435",
                            transform: "translate(15536 -9208)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                              id: "Ellipse_602",
                              "data-name": "Ellipse 602",
                              cx: "15",
                              cy: "15",
                              r: "14",
                              transform: "translate(-15536 9208)",
                              fill: "none",
                              stroke: "#978C21",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("circle", {
                              id: "Ellipse_603",
                              "data-name": "Ellipse 603",
                              cx: "15",
                              cy: "50",
                              r: "15",
                              transform: "translate(-15536 9208)",
                              fill: "#978c21"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("path", {
                            id: "Path_2114",
                            "data-name": "Path 2114",
                            d: "M1146.9,113.13a2.813,2.813,0,0,0-2.813-2.813h-7.195a2.813,2.813,0,0,0-2.813,2.813v3.348a2.813,2.813,0,0,0,2.813,2.813h7.195a2.813,2.813,0,0,0,2.813-2.813Zm-4.231,1.925-3.226,1.6c-.126.068-.556-.023-.556-.167v-3.276c0-.146.433-.237.56-.165l3.089,1.68C1142.661,114.8,1142.8,114.985,1142.666,115.056Z",
                            transform: "translate(-1125.074 -99.317)",
                            fill: "#978C21"
                          })]
                        })
                      })
                    })]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'who' ? 'visible' : 'hidden', " "),
                  "data-tab": 'who',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Who We Are"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                    children: "Shanta Securities Limited is one of the top brokerage houses in Bangladesh with Innovative Financial Services and Capital Market Solutions."
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'core' ? 'visible' : 'hidden', " "),
                  "data-tab": 'core',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Our Core Values"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                    children: "Shanta Group is also one of the key members of the STS Group - the promoter of the world class Apollo Hospitals Dhaka, International School Dhaka (ISD), the only International Baccalaureate (IB) School of the country, and the Delhi Public School, Dhaka."
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'directors' ? 'visible' : 'hidden', " "),
                  "data-tab": 'directors',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Our Board"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                    children: "Shanta Group is also one of the key members of the STS Group - the promoter of the world class Apollo Hospitals Dhaka, International School Dhaka (ISD), the only International Baccalaureate (IB) School of the country, and the Delhi Public School, Dhaka."
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'experts' ? 'visible' : 'hidden', " "),
                  "data-tab": 'experts',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Our Team"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                    children: "Shanta Group is also one of the key members of the STS Group - the promoter of the world class Apollo Hospitals Dhaka, International School Dhaka (ISD), the only International Baccalaureate (IB) School of the country, and the Delhi Public School, Dhaka."
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'services' ? 'visible' : 'hidden', " "),
                  "data-tab": 'services',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Our Services"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("p", {
                    children: ["We provide advanced financial services that cater to a wide spectrum ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), "of brokerage and investment needs."]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'invest' ? 'visible' : 'hidden', " "),
                  "data-tab": 'invest',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Investment Calculator"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("p", {
                    children: ["Uncover missed opportunities - calculate potential earnings ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), " from earlier capital market investments."]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'research' ? 'visible' : 'hidden', " "),
                  "data-tab": 'research',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Research Center"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("p", {
                    children: ["Stay up-to-date about investment opportunities with our ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), " economic research center."]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'pathshala' ? 'visible' : 'hidden', " "),
                  "data-tab": 'pathshala',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Shanta Financial Literacy Program"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("p", {
                    children: ["Learn about personal finance, investment, financial analytics, ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("br", {}), " fundamental analytics."]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab ".concat(hoveredAttr === 'career' ? 'visible' : 'hidden', " "),
                  "data-tab": 'career',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
                    children: "Career"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                    children: "Invest your talent and progress your career with stock marketers at Shanta."
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "menu-tab newsletter ".concat(hoveredAttr === 'subscribe' ? 'visible' : 'hidden', " "),
                  "data-tab": 'subscribe',
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    noanim: true,
                    margin: '0 0 40px 0',
                    text: 'Stay informed, and beat your busy schedule with Daily Newsflash on the go!'
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                    className: "",
                    onSubmit: handleSubmit(onSubmit, onError),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"].Group */ .Z.Group, {
                      className: "form-group",
                      controlId: "formBasicEmail",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"].Control */ .Z.Control, _objectSpread(_objectSpread({
                        className: formState !== null && formState !== void 0 && (_formState$errors = formState.errors) !== null && _formState$errors !== void 0 && (_formState$errors$ema = _formState$errors.email) !== null && _formState$errors$ema !== void 0 && _formState$errors$ema.message ? 'has-error form-control-lg' : 'form-control-lg'
                      }, register("email", {
                        required: {
                          value: true,
                          message: 'please enter your email'
                        },
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: 'please enter a valid email address'
                        }
                      })), {}, {
                        type: "email",
                        placeholder: "Your Email Address*"
                      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                        className: "dc-btn-submit",
                        onClick: handleSubmit(onSubmit, onError),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                          width: '100',
                          text: 'Subscribe',
                          color: '#FFFFFF',
                          hoverBackground: '#3C3C3B',
                          background: '#978C21'
                        })
                      })]
                    })
                  })]
                })]
              })]
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "search-desktop",
          ref: searchItemRef,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "clickto clickto_close",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsX */ .z3f, {})
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
              onSubmit: searchSubmit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"].Group */ .Z.Group, {
                className: "search-input",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"].Control */ .Z.Control, {
                  value: searchInput,
                  onChange: function onChange(e) {
                    return handleInput(e);
                  },
                  type: "text",
                  placeholder: "Search\r "
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                  type: "submit",
                  children: "Search"
                })]
              })
            })]
          })
        })]
      })
    })]
  });
};

var StyledDesktopMenu = styled_components__WEBPACK_IMPORTED_MODULE_21__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "MainMenu__StyledDesktopMenu",
  componentId: "sc-ew14u2-0"
})(["height:95px;position:fixed;z-index:99999;width:100%;background:rgba(0,0,0,0.3);box-shadow:0 0 20px rgba(0,0,0,0.20);top:0;left:0;right:0;transition:all 0.4s cubic-bezier(0.4,0,0,1);sub,sup{vertical-align:top;}.all{margin-bottom:40px;a{margin-bottom:5px !important;&:last-child{margin-bottom:0 !important;}}}.overlay{height:100vh;width:100%;top:0;left:0;right:0;bottom:0;z-index:-1;position:fixed;touch-action:none;background-color:rgba(0,0,0,0.5);-webkit-tap-highlight-color:transparent;}.container{position:relative;z-index:3;}.sticky_logo{display:none;transition-delay:0.8s;.global-image{img{height:auto !important;}}}.search-desktop{background-color:#F9F9F9;align-content:center;flex-wrap:wrap;position:fixed;width:100%;left:0;right:0;top:95px;height:0;display:none;opacity:0;overflow:hidden;z-index:9;box-shadow:0 1px 6px rgb(0 0 0 / 10%);.clickto_close{cursor:pointer;}.container{position:relative;opacity:0;}position:absolute;svg{position:absolute;right:15px;top:-50px;z-index:3;}form{min-width:100%;.search-input{button,p,a{box-shadow:none;border:none;background-color:transparent;position:absolute;right:0;top:0;bottom:0;margin:auto;height:fit-content;font-size:12px;line-height:18px;color:#221f1f;transition:color .3s cubic-bezier(0.4,0,0,1);cursor:pointer;&:hover{color:#D0CA10;}}span{position:absolute !important;bottom:18px;}.form-control{border:none;border-radius:0;border-bottom:1px solid #221F1F;padding-left:0px;padding-bottom:9px;padding-top:0;height:50px;font-size:32px;line-height:36px;font-weight:600;color:black;background-color:#F9F9F9;::placeholder{font-size:32px;line-height:36px;font-weight:600;color:rgba(60,60,59,0.5);}}}}&__menu{margin-top:23px;min-width:100%;p{font-size:12px;color:#ed1b34;font-weight:600;line-height:18px;margin-bottom:13px;}ul{display:inline-flex;li{a{font-size:16px;font-weight:600;line-height:22px;color:#221f1f;display:flex;margin-right:30px;}&:nth-last-child(1){a{margin-right:0;}}}}}}.desktop-menu__top{height:auto;display:flex;align-items:center;padding:25px 0;.desktop-hamburger{cursor:pointer;margin-right:30px;display:flex;align-items:center;justify-content:center;width:30px;.close{svg{width:25px;height:25px;g{transform:translate(-96.586px,-36.086px)}}#Line_3,#Line_4,#Line_5{fill:none;stroke:#fff;strokeLinecap:round;stroke-width:2;}#Line_3{transform:translate(98px,58.713px) rotate(-45deg);}#Line_4{transform:translate(98px,37.5px) rotate(45deg);}#Line_5{transform:translate(98px,58.713px) rotate(-45deg);}&:hover{}}svg{transition:1s all ease;g{}line{transition:1s all ease;}}&:hover{}}&__logo{display:flex;a{display:flex;position:relative;z-index:33;img{height:48px;width:200px;}}}ul{li{overflow:hidden;color:#ffffff;margin-right:30px;display:flex;font-size:16px;font-weight:500;align-items:center;cursor:pointer;position:relative;background:#978C21;border-radius:25px;overflow:hidden;&.dc-btn{a{font-size:16px;font-weight:500;line-height:24px;overflow:hidden;min-width:160px;display:flex;align-items:center;justify-content:center;&:after{background:#3C3C3B;content:\"\";position:absolute;left:0;right:0;top:0;bottom:0;height:100%;display:block !important;border-radius:25px;transition:0.6s all cubic-bezier(0.4,0,0,1);transform:translateY(100%);}&:hover{color:white !important;&:after{transform:translateY(0);}}span{top:1px;}}}&:nth-last-child(1){margin-right:0;a{background:transparent !important;}}&:first-child{background:transparent !important;padding:0;&:after{display:none !important;}a{background:transparent !important;padding:0;font-size:16px;span{display:flex;align-items:center;}svg{path,#Rectangle_493{transition:0.8s all ease;}}&:after{display:none !important;}&:hover{svg{#Rectangle_493{opacity:1;stroke-dasharray:520px;}path{}}}}}&:last-child{padding:0;background:transparent;&:after{display:none;}svg{#Ellipse_19{transition:0.8s all ease;}}&:hover{&:after{height:32px !important;width:32px !important;}}}a{display:flex;align-items:center;font-size:12px;font-weight:400;line-height:18px;color:#FFFFFF;padding:10px 15px;span{position:relative;z-index:1;&.image-circle{height:32px;width:32px;border-radius:50%;background-color:#221F1F;display:flex;align-items:center;justify-content:center;margin-left:10px;}}&:hover{}}ul{position:absolute;flex-wrap:wrap;background-color:#F9F9F9;width:170px;z-index:99;padding:20px 0 20px 0;opacity:0;height:0;display:none;overflow:hidden;right:0;top:70px;li{display:block;min-width:100%;border:none;padding:0 20px 0 20px;opacity:0;a{display:flex;padding:0 0 20px 0;border-bottom:1px solid rgba(34,31,31,0.10);color:#221f1f;width:100%;margin-bottom:13px;position:relative;text-transform:none;svg{position:absolute;right:30px;color:#D0CA10;opacity:0;transition:all .3s cubic-bezier(0.4,0,0,1);top:3px;}&:hover{}}a{font-size:12px;font-weight:600;}&:nth-last-child(1){a{margin-bottom:0;border:none;padding-bottom:0;}}&:hover{svg{right:0;opacity:1;path{fill:#D80028;}}}ul{display:block !important;height:auto !important;position:absolute;width:270px;z-index:2;left:calc(100% + 0px);top:-20px;opacity:0;transition:opacity .3s cubic-bezier(0.4,0,0,1);li{opacity:1 !important;}}&:hover{ul{opacity:1 !important;}}}}}}}.desktop-menu__bottom{position:fixed;left:0;right:0;top:95px;height:0;overflow:hidden;&:after{content:'';position:absolute;right:0;top:0;bottom:0;height:100%;width:100%;background:white;}.mega_menu{overflow:hidden;position:relative;z-index:1;}background:transparent;.mega_menu{width:100%;overflow:hidden;background:transparent;display:flex;padding:0;height:0;.content_wrap{width:34.5%;min-width:34.5%;position:relative;background:#f2f2f2;padding-left:", "px!important;padding-top:40px;padding-right:70px;padding-bottom:40px;height:100%;border-right:1px solid rgba(198,198,198,0.5);li{padding-bottom:10px;border-bottom:1px solid rgba(60,60,59,0.1);margin-bottom:10px;opacity:0;&.last{margin-bottom:0;border-bottom:none;}&.active{a{color:", ";}svg{opacity:1 !important;}}a{font-size:16px;font-weight:500;color:#3C3C3B;cursor:pointer;svg{margin-left:12px;opacity:0;transition:1s all ease;@media (min-width:1600px){bottom:2px;position:relative;}path{fill:#978C21;}}&:hover{color:", ";svg{opacity:1 !important;}}}}.dc-btn{opacity:0;}&:after{position:absolute;right:20px;z-index:2;height:calc(100% + 150px);width:1px;top:-60px;bottom:0;background:rgba(79,97,107,0.2);min-height:360px;}}.middle-menu{width:0;position:relative;background:#F8F8F8;padding-left:0;padding-top:40px;padding-bottom:40px;padding-right:0px;height:auto;opacity:0;border-right:1px solid rgba(198,198,198,0.5);transform:translateX(-100%);z-index:-1;li{padding-bottom:15px;border-bottom:1px solid rgba(60,60,59,0.1);margin-bottom:15px;opacity:0;transform:translateX(-100%);min-width:300px;@media (min-width:160px){min-width:560px;}@media (min-width:1536px){min-width:360px;}&.last{margin-bottom:0;border-bottom:none;}a{font-size:16px;font-weight:500;color:#3C3C3B;svg{margin-left:12px;opacity:0;transition:1s all ease;path{fill:#978C21;}}&:hover{color:", ";svg{opacity:1 !important;}}}}.dc-btn{opacity:0;}&:after{position:absolute;right:20px;z-index:2;height:calc(100% + 150px);width:1px;top:-60px;bottom:0;background:rgba(79,97,107,0.2);min-height:360px;}}.fixed_menu{width:65.5%;padding-right:", "px;padding-left:70px;padding-top:40px;padding-bottom:40px;height:auto;position:relative;background:#fff;.content{opacity:0;h3{color:#3C3C3B;font-size:32px;line-height:44px;font-weight:500;margin-bottom:40px;span{color:", ";}}p{font-size:16px;font-weight:400;color:rgba(60,60,59,0.5);line-height:24px;margin-bottom:10px;}a{font-size:16px;font-weight:400;color:#3C3C3B;display:inline-block;line-height:24px;margin-bottom:40px;}}.social{display:flex;flex-direction:row;svg{overflow:hidden;border-radius:50%;#Ellipse_603,path{transition:1s all cubic-bezier(.25,.74,.22,.99);}}li{margin-right:20px;opacity:0;&:first-child{margin-left:0;}a{&:hover{svg{#Ellipse_603{cy:15px;}path{fill:white;}}}}}}.menu-tab{position:absolute;left:0;right:0;bottom:0;top:0;height:100%;width:100%;padding:40px 79px 40px 70px;opacity:0;transition:0.5s all ease;visibility:hidden;&.visible{transition:0.5s all ease;opacity:1 !important;visibility:visible !important;}&.hidden{transition:0.5s all ease;visibility:hidden;opacity:0;}h3{font-size:24px;font-weight:500;line-height:32px;color:#3C3C3B;margin-bottom:20px;}p{font-size:16px;font-weight:500;line-height:24px;color:#3C3C3B;}.form-group{position:relative;.form-control{height:45px;background-color:transparent;border-radius:40px;font-size:16px;font-weight:500;padding-left:30px;color:#3C3C3B;autocomplete:off;border-color:rgba(60,60,59,0.5);::placeholder{color:rgba(60,60,59,0.5);font-size:16px;font-weight:500;outline:none;border:none;}:focus{outline:none;outline-color:#3C3C3B;border-color:#3C3C3B;}}.dc-btn-submit{position:absolute;top:0;right:0;.dc-btn{height:45px;}a{display:flex;height:100%;width:100%;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;font-size:16px;font-weight:500;margin:0px;line-height:18px;color:#3C3C3B;text-transform:capitalize;border:none;letter-spacing:0px;position:relative;border-radius:30px;overflow:hidden;span{}}}}}}}&__parent-ul{display:flex;width:100%;height:100%;position:relative;justify-content:flex-end;> li{display:flex;margin-right:30px;position:relative;align-items:center;&:last-child{margin-right:0;}&:hover{&:after{width:100%;}a{}}}&:after{position:absolute;height:2px;width:0;left:0;top:-1.5px;background-color:#D0CA10;transition:width .6s cubic-bezier(0.87,0,0.13,1);}}@media (max-width:1199px){.desktop-menu__top ul li{margin-right:20px;&.search{margin-right:25px;width:115px;}}.desktop-menu__bottom ul li{margin-right:15px;a{font-size:10px;}}}@media (max-width:992px){display:none;}}@media (max-width:992px){display:none;}"], function (props) {
  return props.offset;
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__/* .hover */ .Mr, function (props) {
  return props.offset;
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__/* .hover */ .Mr);
var StyledMobileMenu = styled_components__WEBPACK_IMPORTED_MODULE_21__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "MainMenu__StyledMobileMenu",
  componentId: "sc-ew14u2-1"
})(["position:fixed;top:0;left:0;width:100%;height:80px;z-index:99999;display:flex;align-items:center;transition:background .4s cubic-bezier(0.4,0,0,1);overflow:visible !important;background:rgba(0,0,0,0.3);box-shadow:0 0 20px rgba(0,0,0,0.20);.call_icon{height:20px;}.forClose{display:none !important;a{img{height:40px !important;}}}&.menu-open{background:rgba(255,255,255,1) !important;.forNormal{display:none !important;}.forClose{display:block !important;}}.mobile-menu{.logo{display:flex;align-items:center;padding:0 15px;span{width:220px !important;}a{display:flex;svg,img{height:40px;width:200px;}}}.hamburger{position:relative;display:flex;align-items:center;span{position:absolute !important;right:15px !important;display:flex;p{font-size:16px;font-weight:400;line-height:20px;color:#F9F9F9;margin:0 10px 0 0;}&:nth-of-type(2){display:none !important;}}&.menu-open span{&:nth-of-type(1){display:none !important;}&:nth-of-type(2){display:flex !important;right:20px !important;}}}&__items{display:none;position:absolute;opacity:0;background-color:#F8F8F8;height:calc(100vh - 80px);top:80px;left:0;width:100%;z-index:99;padding:60px 15px 120px 15px;overflow:auto;transition:opacity .5s cubic-bezier(0.4,0,0,1);overflow-y:scroll;&:after{position:absolute;left:0;right:0;top:0;background:#C4C4C4;height:1px;margin:0 auto;width:calc(100% - 30px);}&__top{ul{li{&:first-child{a{justify-content:center;}svg{width:100%;#_16634{fill:#3C3C3B;}#Rectangle_493{transition:1s all ease}width:100%;position:absolute;left:0;right:0;}&:hover{span{color:rgb(60,60,59);}svg{#Rectangle_493{opacity:1;stroke-dasharray:520px;}}}}&:last-child{a{justify-content:center;}svg{width:100%;#_16634{fill:#3C3C3B;}#Rectangle_493{transition:1s all ease}width:100%;position:absolute;left:0;right:0;}&:hover{span{color:rgb(60,60,59);}svg{#Rectangle_493{opacity:1;stroke-dasharray:520px;}}}}a{width:100%;display:flex;align-items:center;justify-content:flex-start;position:relative;margin-bottom:30px;img{margin-right:10px;}span{display:flex;}}&:nth-last-child(1) a{a{justify-content:center;}svg{width:100%;#_16634{fill:#3C3C3B;}#Rectangle_493{transition:1s all ease}width:100%;position:absolute;left:0;right:0;}span{svg{display:flex;position:unset;margin-right:8px;}}&:hover{span{color:rgb(60,60,59);}svg{#Rectangle_493{opacity:1;stroke-dasharray:520px;}}}}}}margin-bottom:80px;}&__bottom{.submenu{padding:60px 15px 30px;position:fixed;right:0;top:80px;left:0;bottom:0;background:#F8F8F8;width:100%;opacity:0;visibility:hidden;transition:0.7s all cubic-bezier(0.4,0,0,1);transform:translateX(100%);overflow-x:scroll;z-index:9;&::-webkit-scrollbar{display:none;}.main_title{text-align:left;display:flex;color:#3C3C3B;margin-bottom:60px;font-weight:500;font-size:20px;line-height:28px;svg{margin-right:20px;position:relative;z-index:-1;}}padding-bottom:18px;border-bottom:1px solid rgba(225,228,230,0.5) !important;margin-bottom:18px;&:last-child{margin-bottom:0;border-bottom:none !important;}.form-group{position:relative;.form-control{height:45px;background-color:transparent;border-radius:40px;font-size:16px;font-weight:500;padding-left:30px;color:#3C3C3B;autocomplete:off;border-color:rgba(60,60,59,0.5);::placeholder{color:rgba(60,60,59,0.5);font-size:16px;font-weight:500;outline:none;border:none;}:focus{outline:none;outline-color:#3C3C3B;border-color:#3C3C3B;}}.dc-btn-submit{position:absolute;top:0;right:0;.dc-btn{height:45px;}a{display:flex;height:100%;width:100%;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;font-size:16px;font-weight:500;margin:0px;line-height:18px;color:#3C3C3B;text-transform:capitalize;border:none;letter-spacing:0px;position:relative;border-radius:30px;overflow:hidden;span{}}}}a{color:#3C3C3B;font-weight:500;font-size:20px;line-height:28px;}&.visible{opacity:1;visibility:visible;transform:translateX(0);}&.hidden{opacity:0;visibility:hidden;transform:translateX(100%);}}}&__ul{li{padding-bottom:18px;border-bottom:1px solid rgba(225,228,230,0.5) !important;margin-bottom:18px;&:last-child{margin-bottom:0;border-bottom:none !important;}a{color:#3C3C3B;font-weight:500;font-size:20px;line-height:28px;}}}}&.menu-open{.mobile-menu__items{display:block;}}.main-child-sub{a{display:flex;justify-content:space-between;}}.main_child{a{width:100%;padding:0;box-shadow:none;display:flex;justify-content:space-between;@media (max-width:767px){img{z-index:-1;position:relative;}}p{margin:0;font-size:22px;line-height:28px;text-transform:capitalize;font-weight:bold;padding-right:30px;width:100%;}span{&:nth-last-child(2){display:none !important;}&:nth-last-child(1){display:block !important;}}&.collapsed{span{&:nth-last-child(2){display:block !important;}&:nth-last-child(1){display:none !important;}}}&.collapsed{border-bottom:1px solid #E1E4E6;}}&.submenu-open-mb{.submenu{opacity:1;visibility:visible;transform:translateX(0);}.submenu-open-next{.mega_sub{opacity:1;visibility:visible;transform:translateX(0);}}.submenu-open-next-next{.mega_sub_sub{opacity:1;visibility:visible;transform:translateX(0);}}}.submenu{padding:60px 15px 30px;position:fixed;right:0;top:80px;left:0;bottom:0;background:#F8F8F8;width:100%;opacity:0;visibility:hidden;transition:0.7s all cubic-bezier(0.4,0,0,1);transform:translateX(100%);overflow-x:scroll;z-index:9;&::-webkit-scrollbar{display:none;}.main_title{text-align:left;display:flex;color:#3C3C3B;margin-bottom:60px;font-weight:500;font-size:20px;line-height:28px;svg{margin-right:20px;position:relative;z-index:-1;}}padding-bottom:18px;border-bottom:1px solid rgba(225,228,230,0.5) !important;margin-bottom:18px;&:last-child{margin-bottom:0;border-bottom:none !important;}a{color:#3C3C3B;font-weight:500;font-size:20px;line-height:28px;}}.fotter_menu{margin-top:150px;h3{font-size:32px;color:#4F616B;line-height:32px;}p{font-size:14px;font-weight:400;line-height:20px;color:#4F616B;}.footer{margin-top:40px;a{font-size:24px;font-weight:400;line-height:28px;color:#4F616B;padding:0;display:block;margin:0 0 10px;border:none;&:last-child{margin:0;}}}}&:nth-last-child(1){.accordion-button{}}}}@media (min-width:993px){display:none;}"]);
var StyledMobileBottomBar = styled_components__WEBPACK_IMPORTED_MODULE_21__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "MainMenu__StyledMobileBottomBar",
  componentId: "sc-ew14u2-2"
})(["position:fixed;bottom:0;height:55px;background-color:#FFF;box-shadow:0 0 5px rgba(0,0,0,0.20);width:100%;z-index:9;.mobile-bottom-bar__buttons{padding-left:40px;padding-right:40px;display:flex;align-items:center;justify-content:space-between;height:100%;li{display:flex;align-items:center;justify-content:center;}}.mobile-bottom-bar__account{position:fixed;width:100%;padding:110px 20px 60px 20px;bottom:0;left:0;right:0;background-color:#fff;box-shadow:0 0 5px rgba(0,0,0,0.20);visibility:hidden;transform:translateY(100%);transition:all .6s cubic-bezier(0.87,0,0.13,1);svg{position:absolute;right:13px;top:50px;font-size:40px;color:black;}p{font-size:16px;color:#D0CA10;line-height:22px;margin-bottom:40px;font-weight:600;}ul{width:100%;li{a{display:flex;font-size:12px;line-height:18px;font-weight:600;padding-bottom:20px;border-bottom:1px solid rgba(34,31,31,0.1);margin-bottom:20px;}&:nth-last-of-type(1){a{margin-bottom:0;border-bottom:0;}}}}&.open{transform:none;visibility:visible;}}.mobile-bottom-bar__search{position:fixed;width:100%;padding:110px 20px 60px 20px;bottom:0;left:0;right:0;background-color:#fff;box-shadow:0 0 5px rgba(0,0,0,0.20);visibility:hidden;transform:translateY(100%);transition:all .6s cubic-bezier(0.87,0,0.13,1);svg{position:absolute;right:13px;top:50px;font-size:40px;color:black;}p{font-size:16px;color:#D0CA10;line-height:22px;margin-bottom:20px;margin-top:45px;font-weight:600;}.search-input{position:relative;button,p,a{box-shadow:none;border:none;background-color:transparent;position:absolute;right:0;top:0;bottom:0;margin:auto;height:fit-content;font-size:12px;line-height:18px;color:#221f1f;transition:color .3s cubic-bezier(0.4,0,0,1);cursor:pointer;&:hover{}}span{position:absolute !important;bottom:18px;}.form-control{border:none;border-radius:0;border-bottom:1px solid #221F1F;padding-left:30px;padding-right:60px;padding-bottom:9px;padding-top:0;height:50px;font-size:16px;line-height:22px;font-weight:600;color:rgba(34,31,31,0.20);::placeholder{font-size:16px;line-height:22px;font-weight:600;color:rgba(34,31,31,0.20);}}}ul{li{a{font-size:16px;font-weight:600;line-height:22px;display:flex;margin-bottom:10px;}&:nth-last-of-type(1){a{margin-bottom:0;}}}}&.open{transform:none;visibility:visible;}}@media (min-width:993px){display:none;}.has-child-sub.open_submenu > a svg{opacity:1;right:0;}.has-child-sub-sub a:hover{svg{opacity:1 !important;}}@media (min-width:1024px) and (max-width:1440px ){.desktop-menu__bottom .mega_menu .fixed_menu .menu-tab h3{font-size:22px;font-weight:500;line-height:25px;}}"]);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(MainMenu));

/***/ }),

/***/ 93264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68312);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Title = function Title(_ref) {
  var text = _ref.text,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      textTransform = _ref.textTransform,
      margin = _ref.margin,
      padding = _ref.padding,
      borderColor = _ref.borderColor,
      varient = _ref.varient,
      center = _ref.center,
      classname = _ref.classname,
      small_text = _ref.small_text,
      noanim = _ref.noanim,
      h1 = _ref.h1;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledTitle, {
    className: "title fade-up ".concat(classname),
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    lineHeight: lineHeight,
    LetterSpacing: letterSpacing,
    textTransform: textTransform,
    margin: margin,
    padding: padding,
    varient: varient,
    center: center,
    borderColor: borderColor,
    children: text ? h1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("h1", {
      className: "".concat(noanim ? '' : 'split-up'),
      children: [" ", (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text), " "]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("h2", {
      className: "".concat(noanim ? '' : 'split-up'),
      children: [" ", (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text), " "]
    }) : ''
  });
};

var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-n2utlk-0"
})(["margin:", ";position:relative;width:100%;font-family:", ";text-align:", ";padding:", ";h2{font-family:", ";font-size:", "px;line-height:", "px;letter-spacing:-1px;font-weight:", ";color:", ";span{color:", ";}}h1{font-family:", ";font-size:", "px !important;line-height:", "px !important;letter-spacing:-1px !important;font-weight:", " !important;color:", " !important;span{color:", " !important;}}@media (max-width:767px){margin-bottom:40px;padding:0;h2{font-size:35px !important;line-height:42px !important;sub{bottom:9.1px;line-height:inherit;}}h1{font-size:35px !important;line-height:42px !important;sub{bottom:9.1px;line-height:inherit;}}}"], function (props) {
  return props.margin || '0px';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props !== null && props !== void 0 && props.center ? 'center' : '';
}, function (p) {
  return p.padding;
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props.fontSize || 44;
}, function (props) {
  return props.lineHeight || 56;
}, function (props) {
  return props.fontWeight || '500';
}, function (props) {
  return props.color || '#3C3C3B';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .title */ .TN, function (props) {
  return props.fontSize || 44;
}, function (props) {
  return props.lineHeight || 56;
}, function (props) {
  return props.fontWeight || '500';
}, function (props) {
  return props.color || '#3C3C3B';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_4__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Title));

/***/ }),

/***/ 92495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ ApiServices; }
/* harmony export */ });
var ApiServices = {
  POSTS: 'get-req-data/posts',
  PHOTOS: 'get-req-data/photos',
  PAGE_DATA: 'get-req-data/page-data',
  SECTIONS: 'get-req-data/sections',
  SERVICERESEARCH: 'get-req-data/research-documents-all',
  JOB: 'get-req-data/job-list',
  TEAM: 'get-req-data/team-list',
  CHILD_PAGE: 'get-req-data/child-pages',
  PAGE_POST_DATA: 'get-req-data/page-post-data',
  SEARCH: 'get-req-data/search',
  SEARCHCAMPAIGN: 'get-req-data/campaign-search',
  ALL_CATEGORY: 'get-req-data/all-category',
  CHILD_CATEGORY: 'get-req-data/child-category',
  PRODUCT_DATA: 'get-req-data/product-data',
  ALL_PRODUCTS: 'get-req-data/all-products',
  POST_FORM: 'post-req-data/form-submit',
  // POST_FORM: 'form-fields?form_id=contact-form',
  // SERVICE_FORM: 'get-req-data/form-fields?form_id=our-services-form',
  SERVICE_FORM: 'post-req-data/form-submit',
  // GETINTOUCH_FORM: 'get-req-data/form-fields?form_id=get-in-touch',
  GETINTOUCH_FORM: 'post-req-data/form-submit',
  FIND_DEALER: 'get-req-data/dealer-location',
  // GOOGLE_PLACE_NEARBY:"place/nearbysearch/json"
  SETTINGS: 'get-req-data/settings-data',
  COURSEDATA: 'get-req-data/course-data',
  BlogData: 'get-req-data/blog-data',
  RESEARCHLIST: 'get-req-data/research-list',
  ADDSUBSCRIP: 'post-req-data/add-subscriber',
  SUBMITFORM: 'post-req-data/form-submit',
  INVESTOR: 'get-req-data/investor-data',
  REARCHLISTCAT: 'get-req-data/research-documents',
  BLOGCATEGORY: 'get-req-data/blog-list?category_id=21',
  HOMEJSON: 'json-data/home'
};

/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

}]);